import { privacyTermsTranslations } from './i18n-privacy-terms';

export type Language = 'en' | 'ar' | 'fa' | 'ru';

export interface Translations {
  [key: string]: string;
}

// Base translations for each language (non-privacy/terms content)
const baseTranslations: Record<Language, Translations> = {
  en: {
    // Navigation
    'nav.shop': 'Shop',
    'nav.cart': 'My Cart',
    'nav.account': 'My Account',
    'nav.dashboard': 'Dashboard',
    'nav.products': 'Products',
    'nav.orders': 'Orders',

    // Hamburger Menu
    'menu.home': 'Home',
    'menu.categories': 'Categories',
    'menu.brands': 'Brands',
    'menu.newArrivals': 'New Arrivals',
    'menu.sale': 'Sale',
    'menu.aboutUs': 'About Us',
    'menu.contact': 'Contact',
    'menu.privacyPolicy': 'Privacy Policy',
    'menu.termsConditions': 'Terms & Conditions',

    // Common
    'common.search': 'Search',
    'common.searchPlaceholder': 'type to search',
    'common.filter': 'Filter',
    'common.filters': 'Filters',
    'common.sort': 'Sort',
    'common.add': 'Add',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.close': 'Close',
    'common.loading': 'Loading...',
    'common.price': 'Price',
    'common.quantity': 'Quantity',
    'common.total': 'Total',
    'common.clearAllFilters': 'Clear All Filters',
    'common.noProductsFound': 'No products found',
    'common.adjustFilters': '_TRY adjusting your filters or search query',

    // Product Catalog
    'catalog.welcome': 'Welcome!',
    'catalog.description': 'Discover our curated collection of premium beauty products',
    'catalog.gridView': 'Grid view',
    'catalog.listView': 'List view',
    'catalog.addedToCart': 'Product added to cart successfully!',
    'catalog.brandName': 'CELINE CLAIRE',
    'catalog.tagline': 'for Unique, Unmatched, Lasting Results',
    'catalog.callToAction': 'YOU MUST TRY IT TO BELIEVE IT!',
    'catalog.uniqueTitle': 'Celine Claire is Unique',
    'catalog.uniqueSubtitle': 'unlike any other',
    'catalog.uniqueAction': 'learn why',
    'catalog.expertTitle': 'Celine Claire is Expert',
    'catalog.expertSubtitle': 'get best advice',
    'catalog.expertAction': 'Learn how',
    'catalog.caresTitle': 'Celine Claire Cares',
    'catalog.caresSubtitle': 'seek medical help',
    'catalog.caresAction': 'Get healthy!',

    // Expert Modal - Holistic Hair Care (English)
    'expert.modal.title': 'Celine Claire Expert Advice',
    'expert.modal.intro': 'Embrace Celine Claire\'s holistic approach to hair care to unlock your hair\'s true potential!',
    'expert.modal.paragraph1': 'This carefully designed Test will help you not only choose the best suitable product specific to your needs, but also offer expert solutions that go beyond beauty cosmetic spending!',
    'expert.modal.paragraph2': 'At Celine, we understand that your hair is more than just a style statement; it\'s a reflection of your overall health, lifestyle and even your emotional or psychological state.',
    'expert.modal.paragraph3': 'We wish to help you understand that factors such as stress levels, diet, daily routines, and even your environment play a crucial role in the health of your hair and scalp.',
    'expert.modal.paragraph4': 'While our products are recognised and celebrated for their unique functionality and long-lasting results, we are committed to providing you with more than just luxurious quality.',
    'expert.modal.paragraph5': 'We want to support you with knowledge about the various factors affecting your hair health so you can achieve the best possible results, not only invest in products that treat the surface.',
    'expert.modal.toggleTitle': 'click here to see the basic factors',
    'expert.modal.factor1.title': '**Stress Levels:**',
    'expert.modal.factor1.content': 'High stress can lead to hair thinning and loss. Managing stress through mindfulness practices, exercise, and proper sleep can promote a healthier scalp and follicles.',
    'expert.modal.factor2.title': '**Diet:**',
    'expert.modal.factor2.content': 'A balanced diet rich in vitamins and minerals is essential. Foods high in Omega-3s, vitamins A, C, D, and E, along with zinc and iron, contribute to stronger, shinier hair. Consider incorporating nutrient-dense foods to nourish your hair from the inside out.',
    'expert.modal.factor3.title': '**Daily Routine:**',
    'expert.modal.factor3.content': 'Your daily habits should support your hair health. Gentle cleansing, conditioning, and minimizing heat styling can lead to stronger, more resilient hair. Establish routines that pamper your scalp and promote hair growth.',
    'expert.modal.factor4.title': '**Lifestyle Choices:**',
    'expert.modal.factor4.content': 'Whether you live in a vibrant urban center or a tranquil village, your lifestyle influences your hair health. Urban environments may expose you to pollution; hence, protective measures like cleansing regularly and using products with antioxidants can mitigate damage. In rural settings, factors like humidity and sun exposure require tailored care for optimal hair health.',
    'expert.modal.factor5.title': '**Climate Considerations:**',
    'expert.modal.factor5.content': 'Different climates can impact your hair\'s moisture levels and strength. Adapting your hair care regimen to include hydrating products in dry climates and protective styles in humid areas will ensure you maintain luscious locks year-round.',
    'expert.modal.paragraph6': 'Allow us to uncover and address all possible underlying issues together, and responsibly ensure, restore and maintain your hair\'s beauty and vitality.',
    'expert.modal.paragraph7': 'Take control of your hair health, click on the button below and undertake our TEST and explore our range of expert solutions that go beyond beauty. Visit our website today to discover how Celine can elevate your hair care routine and enhance your overall well-being. Your journey to healthier hair starts now!',
    'expert.modal.paragraph8': 'On your Test Result page, you may also receive our "SURPRISE GIFT"!',
    'expert.modal.buttonText': 'Take your Hair and Well-being Assessment Test now',

    // Product
    'product.addToCart': 'Add to Cart',
    'product.outOfStock': 'Out of Stock',
    'product.inStock': 'In Stock',
    'product.details': 'Product Details',
    'product.reviews': 'Reviews',
    'product.description': 'Description',

    // Product Names
    'products.arganOil.name': 'Argan Oil',
    'products.hairMask.name': 'Hair Mask',
    'products.purpleRepairMask.name': 'PURPLE REPAIR MASK',
    'products.hairEnhancementShampoo.name': 'Hair Enhancement Shampoo',
    'products.volumiserShampoo.name': 'Volumiser Shampoo',
    'products.volumiserConditioner.name': 'Volumiser Conditioner',
    'products.hydratingShampoo.name': 'HYDRATING SHAMPOO',
    'products.hydratingConditioner.name': 'HYDRATING CONDITIONER',
    'products.cck1And2.name': 'CCK1 & 2 Purifying Shampoo & Keratin Set',
    'products.cck3.name': 'CCK3 Daily Keratin Shampoo',
    'products.cck4.name': 'CCK4 Daily Keratin Conditioner',
    'products.aquaStylingWax.name': 'Aqua Styling Hair Wax',
    'products.deadSeaSaltSpray.name': 'Dead Sea Salt Spray',
    'products.heatShieldSpray.name': 'Heat Shield Spray',
    'products.moisturizingCream.name': 'Moisturizing Cream Leave-in Conditioner',
    'products.curlEssence.name': 'Curl Essence Leave-in Conditioner',
    'products.tecplexKits.name': 'TecPlex Kits Professional',
    'products.tecplexNo3.name': 'TecPlex No.3',
    'products.tecplexNo7.name': 'TecPlex No7 Oil',
    'products.silverShampoo.name': 'SILVER SHAMPOO',
    'products.flexyBrush.name': 'Flexy Single Hair Brush',
    'products.flexyBrushSet.name': 'Professional Flexy Brush Set (4Pcs)',

    // Product Descriptions
    'products.arganOil.description': 'What is argan oil? Argan oil — or "liquid gold," as many refer to it — is made from the fresh kernels of the fruit of the argan tree in Morocco. Pure argan oil has been used for centuries for cooking and as a home remedy for health and beauty, including hair loss. Today it can be found in a number of hair and skin care products including Celine Claire Moroccan Argan Oil. Argan oil has been shown to provide several health benefits when applied to the skin and many of those benefits extend to the hair. Argan oil is full of fatty acids and powerful antioxidants, such as vitamin E, that have been shown to have benefits for your scalp and hair. Here are some of the benefits of argan oil for hair that may help protect against hair loss. Moisturizes and conditions. Argan oil is mostly used as a moisturizer for skin and hair because it is full of fatty acids, mainly oleic acid and linoleic acid. These oils have been shown to lubricate the hair shaft and help your hair maintain moisture. Argan oil is also rich in vitamin E, which provides a fatty layer to your hair and scalp that may help prevent dryness and can help reduce fizziness and boost shine. Improves scalp health Argan oil has anti-inflammatory and antioxidant properties that are good for the skin. This can help prevent or improve skin conditions, including those that can affect the scalp that can cause hair loss, like: psoriasis, seborrheic dermatitis. Prevents styling and coloring damage. The medium-chain fatty acids in argan oil have a protective effect that can help prevent damage from washing and styling. Research shows that oils like Argan oil that is rich in linoleic acid, oleic acid, and palmitic acid, adds a protective layer to the hair that improves combing force and protects the hair from breakage during heat styling. Using the Celine Claire Moroccan Argan Oil help to reduce the formation of split ends, which can result in thicker, healthier looking hair.',
    'products.hydratingShampoo.description': 'Looking for hydrating shampoo that can boost your strands without weighing hair down. This hydrating, daily care shampoo infused with antioxidant-rich argan oil and replenishing nutrients to quench and nurture dry hair. Provides hydration to promote healthy hair for daily cleansing and moisture boosting Argan Oil for shine, softness, smoothness and strength without frizz or split ends. Packed with active ingredients such as Vitamin E that work to smooth hair and repair damage. Features Celine Claire\'s signature Moroccan oil fragrance. Washes without stripping hair moisture, keeping hair cleaner for longer. Suitable for all hair types including straight, wavy, curly, and coily. Works on fine, medium, and thick hair textures. Hydrates dry hair in need of a boost, fights frizz and promotes beautiful natural shine. Key Ingredients: Argan Oil restores elasticity, smoothness, and manageability. Keratin protects cuticles against dryness. Vitamin E combats free radicals to retain moisture and fight hair ageing. Rich clear liquid formula that lathers well and removes product build up from styling products.',
    'products.hydratingConditioner.description': 'Intensely Moisturising Conditioner. Introducing the new Celine Claire Cosmetic Hydrating Conditioner. This wonderful product is the perfect hydration solution for your hair. Frizzed hair got you frazzled? Damaged hair got you down? Revive and restore the look of your hair with this Hydrating Conditioner made with the highest grade Argan Oil. Infused with moisturising Argan oil, this conditioner penetrates the hair shaft, gently softening and detangling while protecting against damage and breakage. This Hydrating Conditioner is made up of cationic surfactants, which help to smooth your hair, as well as emollients, botanical oils, and high-grade silicones. These silicones help your hair. Silicones coat your hair to help to lock out humidity, reduce frizz and make your hair shiny. Vitamin E is another miracle ingredient. Vitamin E may help support a healthy scalp and hair as it has natural antioxidant effects that could assist with maintaining hair growth. The vitamin\'s antioxidant properties could help reduce the amount of oxidative stress and free radicals that cause the hair follicle cells in a person\'s scalp to break down.',
    'products.silverShampoo.description': 'Purple shampoo is color theory at its simplest: The temporary hue makes all types of light and blonde hair look like they are fresh-from-the-salon. Celine Claire has a new purple shampoo that will transform your yellow, brassy blonde tones into a beautiful shade of blonde again. Whether you\'ve gone platinum or just want to brighten up your natural hue, this purple shampoo stop brassiness and revive your shade with just one wash. Stop searching this is the perfect purple formula for you! The secret is that the ultra-violet pigments neutralizers will keep hair from looking brassy or too yellow. This product is perfect for any hair texture and type of blonde. Use this to correct any already existing brassy tones or to brighten bleached, platinum, or silver hair. It gently cleanses and revitalizes hair to give you the most vibrant blonde. This highly pigmented purple shampoo keeps blonde and silver shades and highlights looking their brightest and keeps brassiness at bay. This product has more ultra-violet pigments than ordinary purple shampoos. It is effective in getting the shade of blonde you like without too many trips to the salon. It doesn\'t get much better than that.',
    'products.purpleRepairMask.description': 'Having blonde hair is never easy on your time or wallet. Blonde hair whether you are born with it or it comes at the expense of your stylist requires a lot of work. Celine Claire Cosmetic introduces a brand-new product that aims to make having luscious blonde locks. When we rely on pricey in-salon color treatments to maintain the blonde tresses we need to do upkeep at home. To solve this issue of upkeep in between touch-ups, Celine Claire presents the Celine Claire Purple Repair Mask. This mask is the perfect product to help you in your battle with brassiness. The deep purple tones out the orange and copper tones that develop on blonde hair. Why does this happen? Brassiness can happen due to several factors, such as UV exposure, hard water damage, or chlorine in swimming pools. Our Purple Repair Mask treats unwanted brass warm tones without you having to step foot inside a hair salon. Celine Claire has one of the best complete hair care systems dedicated to blonde hair. Start your blonde hair care journey by washing your luscious locks with the Celine Claire Purple Shampoo once or twice a week. This will depend on how often you shampoo your hair. Follow up on the Celine Claire Purple Repair Mask. This moisturizing product is rich in Argan oil that helps the hair repair damage and remains silky soft. This hair care system is essential for maintaining your blonde color. The repair mask is very rich and is the perfect solution to over-processed and damaged blonde hair.',
    'products.hairMask.description': 'Mascara for hair that intensively moisturizes and conditions damaged hair, restores moisture, and leaves hair silky smooth.',
    'products.hairEnhancementShampoo.description': 'Professional-grade shampoo that strengthens and enhances hair health with advanced formula.',
    'products.volumiserShampoo.description': 'Shampoo that adds volume and body to fine, flat hair without weighing it down.',
    'products.volumiserConditioner.description': 'Lightweight conditioning that complements the volumiser shampoo and maintains volume and adds shine.',
    'products.cck1And2.description': 'Professional keratin treatment system for salon-quality smoothing and frizz control.',
    'products.cck3.description': 'Sulfate-free daily shampoo specially formulated to maintain and extend keratin treatments.',
    'products.cck4.description': 'Nourishing daily conditioner that preserves keratin treatments while adding moisture and shine.',
    'products.aquaStylingWax.description': 'Water-based styling wax that provides flexible hold and texture with a natural finish.',
    'products.deadSeaSaltSpray.description': 'Texturizing spray with Dead Sea minerals that creates beachy waves and adds volume.',
    'products.heatShieldSpray.description': 'Protective spray that shields hair from heat damage up to 230°C while adding shine.',
    'products.moisturizingCream.description': 'Rich leave-in conditioning cream that provides all-day hydration and frizz control.',
    'products.curlEssence.description': 'Curl-defining leave-in conditioner that enhances natural curl pattern and reduces frizz.',
    'products.tecplexKits.description': 'Professional bond-building treatment system that repairs and strengthens damaged hair.',
    'products.tecplexNo3.description': 'At-home hair perfector that rebuilds broken bonds and improves hair strength.',
    'products.tecplexNo7.description': 'Lightweight bonding oil that adds brilliant shine while repairing and protecting hair.',
    'products.flexyBrush.description': 'Flexible detangling brush with soft bristles that glides through wet or dry hair without pulling.',
    'products.flexyBrushSet.description': 'Professional set of 4 flexible detangling brushes for complete hair care - perfect for salons and families.',

    // Cart
    'cart.empty': 'Your cart is empty',
    'cart.checkout': 'Checkout',
    'cart.subtotal': 'Subtotal',
    'cart.shipping': 'Shipping',
    'cart.tax': 'Tax',

    // Auth
    'auth.login': 'Login',
    'auth.register': 'Register',
    'auth.logout': 'Logout',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.forgotPassword': 'Forgot Password?',
    'auth.emailAddress': 'Email Address',
    'auth.enterEmail': 'Enter your email address',
    'auth.enterPassword': 'Enter your password',
    'auth.rememberMe': 'Remember me',
    'auth.signingIn': 'Signing in...',
    'auth.signIn': 'Sign In',
    'auth.orContinueWith': 'Or continue with',
    'auth.google': 'Google',
    'auth.facebook': 'Facebook',
    'auth.loginAs': 'Login As',
    'auth.registerAs': 'Register As',
    'auth.onlineCustomer': 'Online Customer',
    'auth.salonStore': 'Salon or Store',
    'auth.salesRepresentative': 'Sales Representative',
    'auth.management': 'Management',
    'auth.admin': 'Admin',
    'auth.fullName': 'Full Name',
    'auth.enterFullName': 'Enter your full name',
    'auth.confirmPassword': 'Confirm Password',
    'auth.phoneNumber': 'Phone Number',
    'auth.enterPhoneNumber': 'Enter your phone number',
    'auth.whatsappNumber': 'WhatsApp Number',
    'auth.enterWhatsappNumber': 'Enter your WhatsApp number',
    'auth.addressInformation': 'Address Information',
    'auth.street': 'Street Address',
    'auth.enterStreetAddress': 'Enter your street address',
    'auth.city': 'City',
    'auth.enterCity': 'Enter your city',
    'auth.emirateOrState': 'Emirate or State',
    'auth.enterEmirateOrState': 'Enter your emirate or state',
    'auth.country': 'Country',
    'auth.enterCountry': 'Enter your country',
    'auth.zipCode': 'Zip Code',
    'auth.enterZipCode': 'Enter your zip code',
    'auth.agreeToTerms': 'I agree to the terms and conditions',
    'auth.receivePromotions': 'Receive promotional emails',
    'auth.receiveRecommendations': 'Receive product recommendations',
    'auth.creating': 'Creating account...',
    'auth.createAccount': 'Create Account',
    'auth.welcomeBack': 'Hey, nice to see you coming!',
    'auth.welcomeBackDesc': 'C\'mon, hop in!\n\nOr, if you\'re here for the first time, please Register.',
    'auth.createYourAccount': 'Create Your Account',
    'auth.createYourAccountDesc': 'Join CosmeticStore and start your personalized beauty journey today',
    'auth.signInTab': 'Sign In',
    'auth.createAccountTab': 'Create Account',
    'auth.dontHaveAccount': "Don't have an account?",
    'auth.signUpNow': 'Sign up now',
    'auth.alreadyHaveAccount': 'Already have an account?',
    'auth.needHelp': 'Need Help?',
    'auth.liveChatSupport': 'Live Chat Support',
    'auth.available247': 'Available 24/7',
    'auth.emailSupport': 'Email Support',
    'auth.phoneSupport': 'Phone Support',
    'auth.yourSecurityMatters': 'Your Security Matters',
    'auth.secureAuthentication': 'Secure Authentication',
    'auth.secureAuthDesc': 'Your data is protected with industry-standard encryption',
    'auth.privacyProtected': 'Privacy Protected',
    'auth.privacyProtectedDesc': 'We never share your personal information with third parties',
    'auth.verifiedSecure': 'Verified Secure',
    'auth.verifiedSecureDesc': 'SSL certified and PCI compliant for safe transactions',
    'auth.continueAsGuest': 'Continue as Guest',
    'auth.continueAsGuestDesc': 'You can checkout without creating an account, but you\'ll miss out on these benefits:',
    'auth.exclusiveRewards': 'Exclusive Rewards',
    'auth.exclusiveRewardsDesc': 'Earn points on every purchase and unlock special discounts',
    'auth.fasterCheckout': 'Faster Checkout',
    'auth.fasterCheckoutDesc': 'Save your details for quick and easy checkout in the future',
    'auth.orderTracking': 'Order Tracking',
    'auth.orderTrackingDesc': 'Track your shipments and view your complete order history',
    'auth.personalizedExperience': 'Personalized Experience',
    'auth.personalizedExperienceDesc': 'Get product recommendations tailored to your preferences',
    'auth.createAccountAfter': 'You can create an account after checkout',
    'auth.forgotPasswordTitle': 'Forgot Password?',
    'auth.forgotPasswordDesc': 'Enter your email address and we\'ll send you a link to reset your password',
    'auth.sendResetLink': 'Send Reset Link',
    'auth.sending': 'Sending...',
    'auth.checkYourEmail': 'Check Your Email',
    'auth.checkYourEmailDesc': 'We\'ve sent a password reset link to',
    'auth.checkYourEmailDesc2': 'Please check your inbox and follow the instructions.',
    'auth.didntReceiveEmail': 'Didn\'t receive the email? Check your spam folder or try again in a few minutes.',

    // Privacy Policy (legacy keys for backward compatibility)
    'privacy.title': 'Privacy Policy',
    'privacy.companyName': 'Celine Claire Cosmetic',
    'privacy.lastUpdated': 'Last Updated',
    'privacy.tableOfContents': 'Table of Contents',
    'privacy.printPolicy': 'Print Policy',
    'privacy.introduction': 'Introduction',
    'privacy.introText': 'Celine Claire Cosmetic ("we", "us", "our") is committed to protecting your privacy and ensuring your shopping experience is secure and enjoyable. This Privacy Policy explains how we collect, use, and safeguard your personal information when you visit our website, use our services, or make purchases from us.',
    'privacy.yourRights': 'Your Rights',
    'privacy.yourRightsText': 'You have the right to access, correct, or delete your personal information. You also have the right to file a complaint if you believe your privacy rights have been violated.',
    'privacy.dataCollection': 'Data Collection',
    'privacy.dataUsage': 'Data Usage',
    'privacy.dataProtection': 'Data Protection',
    'privacy.thirdParties': 'Third-Party Sharing',
    'privacy.retention': 'Data Retention',
    'privacy.yourChoices': 'Your Choices',
    'privacy.contactUs': 'Contact Us',
    'privacy.backToShopping': 'Back to Shopping',

    // Filters
    'filters.filters': 'Filters',
    'filters.clearAll': 'Clear All',
    'filters.results': 'Results',
    'filters.categories': 'Categories',
    'filters.allProducts': 'All Products',
    'filters.skincare': 'Skincare',
    'filters.makeup': 'Makeup',
    'filters.fragrance': 'Fragrance',
    'filters.haircare': 'Hair Care',
    'filters.priceRange': 'Price Range',
    'filters.brands': 'Brands',
    'filters.skinType': 'Skin Type',
    'filters.normal': 'Normal',
    'filters.dry': 'Dry',
    'filters.oily': 'Oily',
    'filters.combination': 'Combination',
    'filters.sensitive': 'Sensitive',

    // Sort
    'sort.sortBy': 'Sort by:',
    'sort.relevance': 'Relevance',
    'sort.priceLowToHigh': 'Price: Low to High',
    'sort.priceHighToLow': 'Price: High to Low',
    'sort.highestRated': 'Highest Rated',
    'sort.newestFirst': 'Newest First',

    // Currency
    'currency.amount': 'Amount',
    'currency.enterAmount': 'Enter amount',
    'currency.fromCurrency': 'From Currency',
    'currency.convertedAmounts': 'Converted Amounts:',

    // Celine Home Modal
    'celine.modalMessage': 'You are on the way to visit the Celine Claire Cosmetics Home site .... Are you sure you want to leave the Celine Claire Store?',
    'celine.modalSubtext': '... the Celine Home will open in a new window, you can always come back here ... enjoy your journey!',
    'celine.home': 'CELINE Home',
    'celine.cart': 'CART',
    'celine.login': 'LOGIN',

    // Shopping Cart
    'cart.title': 'Shopping Cart',
    'cart.item': 'item',
    'cart.items': 'items',
    'cart.inYourCart': 'in your cart',
    'cart.yourCartIsEmpty': 'Your Cart is Empty',
    'cart.emptyCartMessage': "Looks like you haven't added any beauty products yet. Start shopping to fill your cart!",
    'cart.startShopping': 'Start Shopping',
    'cart.shopByCategory': 'Shop by Category',
    'cart.youMightLike': 'You Might Like',
    'cart.orderSummary': 'Order Summary',
    'cart.estimatedTax': 'Estimated Tax',
    'cart.free': 'FREE',
    'cart.proceedToCheckout': 'Proceed to Checkout',
    'cart.continueShopping': 'Continue Shopping',
    'cart.freeShipping': 'Free Shipping',
    'cart.freeShippingDesc': 'On orders over $50',
    'cart.securePayment': 'Secure Payment',
    'cart.securePaymentDesc': 'SSL encrypted checkout',
    'cart.easyReturns': 'Easy Returns',
    'cart.easyReturnsDesc': '30-day return policy',
    'cart.promoCode': 'Promo Code',
    'cart.codeApplied': 'Code Applied',
    'cart.enterPromoCode': 'Enter promo code',
    'cart.apply': 'Apply',
    'cart.pleaseEnterPromoCode': 'Please enter a promo code',
    'cart.availableCodes': 'Available Codes:',
    'cart.variant': 'Variant',
    'cart.save': 'Save',
    'cart.saveForLater': 'Save for Later',
    'cart.remove': 'Remove',
    'cart.estimatedDelivery': 'Estimated delivery',
    'cart.itemTotal': 'Item Total:',
    'cart.discount': 'Discount',

    // Dashboard
    'dashboard.loadingDashboard': 'Loading dashboard...',
    'dashboard.quickActions': 'Quick Actions',
    'dashboard.recentOrders': 'Recent Orders',
    'dashboard.admin.topSellingProducts': 'Top Selling Products',
    'dashboard.admin.systemAlerts': 'System Alerts',
    'dashboard.management.inventoryAlerts': 'Inventory Alerts',
    'dashboard.management.topCategories': 'Top Categories',
    'dashboard.management.salesTeamPerformance': 'Sales Team Performance',
    'dashboard.sales.leadPipeline': 'Lead Pipeline',
    'dashboard.sales.recentInteractions': 'Recent Interactions',
    'dashboard.sales.yourTopProducts': 'Your Top Products',
    'dashboard.mobileSales.recentClients': 'Recent Clients',
    'dashboard.mobileSales.sampleInventory': 'Sample Inventory',
    'dashboard.mobileSales.commissionBreakdown': 'Commission Breakdown',
    'dashboard.mobileSales.clientVisitLogs': 'Client Visit Logs',
    'dashboard.analytics.analyticsPeriod': 'Analytics Period',
    'dashboard.analytics.selectTimeRange': 'Select time range for data analysis',
    'dashboard.analytics.3months': '3 Months',
    'dashboard.analytics.6months': '6 Months',
    'dashboard.analytics.12months': '12 Months',
    'dashboard.analytics.quickReports': 'Quick Reports',
    'dashboard.realtime.autoRefreshOn': 'Auto-Refresh ON',
    'dashboard.realtime.autoRefreshOff': 'Auto-Refresh OFF',
    'dashboard.realtime.lastUpdated': 'Last updated',
    'dashboard.reports.reportTemplates': 'Report Templates',
    'dashboard.reports.customReportBuilder': 'Custom Report Builder',
    'dashboard.reports.reportHistory': 'Report History',
    'dashboard.reports.preBuiltTemplates': 'Pre-Built Report Templates',
    'dashboard.reports.selectTemplate': 'Select a template for quick report generation',
    'dashboard.reports.accessPreviousReports': 'Access previously generated reports',
    'dashboard.salon.overview': 'Overview',
    'dashboard.salon.invoices': 'Invoices',
    'dashboard.salon.paymentHistory': 'Payment History',
    'dashboard.salon.appointments': 'Appointments',
    'dashboard.salon.inventory': 'Inventory',
    'dashboard.salon.pricingTier': 'Pricing Tier',
    'dashboard.salon.creditLimit': 'Credit Limit',
    'dashboard.salon.currentBalance': 'Current Balance',
    'dashboard.salon.paymentTerms': 'Payment Terms',
  },
  ar: {
    // Navigation
    'nav.shop': 'تسوق',
    'nav.cart': 'سلتي',
    'nav.account': 'حسابي',
    'nav.dashboard': 'لوحة التحكم',
    'nav.products': 'المنتجات',
    'nav.orders': 'الطلبات',

    // Hamburger Menu
    'menu.home': 'الرئيسية',
    'menu.categories': 'الفئات',
    'menu.brands': 'الماركات',
    'menu.newArrivals': 'الوافدون الجدد',
    'menu.sale': 'تخفيضات',
    'menu.aboutUs': 'من نحن',
    'menu.contact': 'اتصل بنا',
    'menu.privacyPolicy': 'سياسة الخصوصية',
    'menu.termsConditions': 'الشروط والأحكام',

    // Common
    'common.search': 'بحث',
    'common.searchPlaceholder': 'اكتب للبحث',
    'common.filter': 'تصفية',
    'common.filters': 'التصفية',
    'common.sort': 'ترتيب',
    'common.add': 'إضافة',
    'common.edit': 'تعديل',
    'common.delete': 'حذف',
    'common.save': 'حفظ',
    'common.cancel': 'إلغاء',
    'common.close': 'إغلاق',
    'common.loading': 'جاري التحميل...',
    'common.price': 'السعر',
    'common.quantity': 'الكمية',
    'common.total': 'المجموع',
    'common.clearAllFilters': 'مسح جميع الفلاتر',
    'common.noProductsFound': 'لم يتم العثور على منتجات',
    'common.adjustFilters': '_TRY adjusting your filters or search query',

    // Product Catalog
    'catalog.welcome': 'مرحباً!',
    'catalog.description': 'اكتشف مجموعتنا المنسقة من منتجات التجميل الفاخرة',
    'catalog.gridView': 'عرض الشبكة',
    'catalog.listView': 'عرض القائمة',
    'catalog.addedToCart': 'تمت إضافة المنتج إلى السلة بنجاح!',
    'catalog.brandName': 'سيلين كلير',
    'catalog.tagline': 'للحصول على نتائج منحصر به فرد، بی‌نظیر و ماندگار',
    'catalog.callToAction': 'يجب أن تجربها لتصدقها!',
    'catalog.uniqueTitle': 'Celine Claire is Unique',
    'catalog.uniqueSubtitle': 'unlike any other',
    'catalog.uniqueAction': 'learn why',
    'catalog.expertTitle': 'Celine Claire is Expert',
    'catalog.expertSubtitle': 'get best advice',
    'catalog.expertAction': 'Learn how',
    'catalog.caresTitle': 'Celine Claire Cares',
    'catalog.caresSubtitle': 'seek medical help',
    'catalog.caresAction': 'Get healthy!',

    // Expert Modal - Holistic Hair Care (Arabic)
    'expert.modal.title': 'نصائح خبراء سيلين كلير',
    'expert.modal.intro': 'احتضن نهج سيلين كلير الشامل للعناية بالشعر لإطلاق العنان للقدرة الحقيقية لشعرك!',
    'expert.modal.paragraph1': 'سيساعدك هذا الاختبار المصمم بعناية ليس فقط على اختيار أفضل منتج مناسب لاحتياجاتك الخاصة، ولكن أيضًا تقديم حلول خبراء تتجاوز الإنفاق على مستحضرات التجميل!',
    'expert.modal.paragraph2': 'في سيلين، نفهم أن شعرك أكثر من مجرد بيان أسلوب؛ إنه انعكاس لصحتك العامة ونمط حياتك وحتى حالتك العاطفية أو النفسية.',
    'expert.modal.paragraph3': 'نرغب في مساعدتك على فهم أن عوامل مثل مستويات التوتر والنظام الغذائي والروتين اليومي وحتى البيئتك تلعب دورًا حاسمًا في صحة شعرك وفروة رأسك.',
    'expert.modal.paragraph4': 'بينما يتم الاعتراف بمنتجاتنا والاحتفال بها لوظائفها الفريدة ونتائجها طويلة الأمد، نحن ملتزمون بتزويدك بأكثر من مجرد جودة فاخرة.',
    'expert.modal.paragraph5': 'نريد دعمك بالمعرفة حول العوامل المختلفة التي تؤثر على صحة شعرك حتى تتمكن من تحقيق أفضل النتائج الممكنة، وليس فقط الاستثمار في المنتجات التي تعالج السطح.',
    'expert.modal.toggleTitle': 'انقر هنا لرؤية العوامل الأساسية',
    'expert.modal.factor1.title': '**مستويات التوتر:**',
    'expert.modal.factor1.content': 'يمكن أن يؤدي التوتر العالي إلى ترقق الشعر وتساقطه. يمكن أن تعزز إدارة التوتر من خلال ممارسات اليقظة والتمارين الرياضية والنوم المناسب فروة رأس وبصيلات أكثر صحة.',
    'expert.modal.factor2.title': '**النظام الغذائي:**',
    'expert.modal.factor2.content': 'النظام الغذائي المتوازن الغني بالفيتامينات والمعادن ضروري. الأطعمة الغنية بأوميغا 3 والفيتامينات A و C و D و E، إلى جانب الزنك والحديد، تساهم في شعر أقوى وأكثر لمعانًا. فكر في دمج الأطعمة الغنية بالمغذيات لتغذية شعرك من الداخل إلى الخارج.',
    'expert.modal.factor3.title': '**الروتين اليومي:**',
    'expert.modal.factor3.content': 'يجب أن تدعم عاداتك اليومية صحة شعرك. يمكن أن يؤدي التنظيف اللطيف والترطيب وتقليل التصفيف بالحرارة إلى شعر أقوى وأكثر مرونة. أنشئ روتينًا يدلل فروة رأسك ويعزز نمو الشعر.',
    'expert.modal.factor4.title': '**خيارات نمط الحياة:**',
    'expert.modal.factor4.content': 'سواء كنت تعيش في مركز حضري نابض بالحياة أو قرية هادئة، فإن نمط حياتك يؤثر على صحة شعرك. قد تعرضك البيئات الحضرية للتلوث؛ وبالتالي، يمكن للتدابير الوقائية مثل التنظيف المنتظم واستخدام المنتجات المحتوية على مضادات الأكسدة أن تخفف من الضرر. في البيئات الريفية، تتطلب عوامل مثل الرطوبة والتعرض للشمس رعاية مخصصة لصحة الشعر المثلى.',
    'expert.modal.factor5.title': '**اعتبارات المناخ:**',
    'expert.modal.factor5.content': 'يمكن أن تؤثر المناخات المختلفة على مستويات الرطوبة وقوة شعرك. سيضمن تكييف نظام العناية بشعرك ليشمل منتجات الترطيب في المناخات الجافة والأنماط الواقية في المناطق الرطوبة الحفاظ على خصلات فاتنة على مدار العام.',
    'expert.modal.paragraph6': 'Allow us to uncover and address all possible underlying issues together, and responsibly ensure, restore and maintain your hair\'s beauty and vitality.',
    'expert.modal.paragraph7': 'Take control of your hair health, click on the button below and undertake our TEST and explore our range of expert solutions that go beyond beauty. Visit our website today to discover how Celine can elevate your hair care routine and enhance your overall well-being. Your journey to healthier hair starts now!',
    'expert.modal.paragraph8': 'In your Test Result page, you may also receive our "SURPRISE GIFT"!',
    'expert.modal.buttonText': 'Take your Hair and Well-being Assessment Test now',

    // Product
    'product.addToCart': 'أضف إلى السلة',
    'product.outOfStock': 'غير متوفر',
    'product.inStock': 'متوفر',
    'product.details': 'تفاصيل المنتج',
    'product.reviews': 'التقييمات',
    'product.description': 'الوصف',

    // Product Names
    'products.arganOil.name': 'زيت الأرغان',
    'products.hairMask.name': 'قناع الشعر',
    'products.purpleRepairMask.name': 'قناع الإصلاح الأرجواني',
    'products.hairEnhancementShampoo.name': 'شامبو تحسين الشعر',
    'products.volumiserShampoo.name': 'شامبو الحجم',
    'products.volumiserConditioner.name': 'بلسم الحجم',
    'products.hydratingShampoo.name': 'شامبو مرطب',
    'products.hydratingConditioner.name': 'بلسم مرطب',
    'products.cck1And2.name': 'مجموعة شامبو التنقية والكيراتين CCK1 و 2',
    'products.cck3.name': 'شامبو الكيراتين اليومي CCK3',
    'products.cck4.name': 'بلسم الكيراتين اليومي CCK4',
    'products.aquaStylingWax.name': 'شمع تصفيف الشعر المائي',
    'products.deadSeaSaltSpray.name': 'رذاذ ملح البحر الميت',
    'products.heatShieldSpray.name': 'رذاذ الحماية من الحرارة',
    'products.moisturizingCream.name': 'كريم مرطب بدون شطف',
    'products.curlEssence.name': 'بلسم جوهر التجعيد بدون شطف',
    'products.tecplexKits.name': 'مجموعات TecPlex الاحترافية',
    'products.tecplexNo3.name': 'TecPlex رقم 3',
    'products.tecplexNo7.name': 'TecPlex No7 Oil',
    'products.silverShampoo.name': 'شامبو فضي',
    'products.flexyBrush.name': 'فرشاة شعر مرنة واحدة',
    'products.flexyBrushSet.name': 'مجموعة فرش مرنة احترافية (4 قطع)',

    // Product Descriptions
    'products.arganOil.description': 'ما هو زيت الأرغان؟ زيت الأرغان - أو "الذهب السائل" كما يشير إليه الكثيرون - مصنوع من حبات طازجة من ثمار شجرة الأرغان في المغرب. تم استخدام زيت الأرغان النقي لعدة قرون للطبخ وكعلاج منزلي للصحة والجمال، بما في ذلك تساقط الشعر. اليوم يمكن العثور عليه في عدد من منتجات العناية بالشعر والبشرة بما في ذلك زيت الأرغان المغربي من سيلين كلير. ثبت أن زيت الأرغان يوفر العديد من الفوائد الصحية عند تطبيقه على الجلد والعديد من هذه الفوائد تمتد إلى الشعر. زيت الأرغان مليء بالأحماض الدهنية ومضادات الأكسدة القوية، مثل فيتامين E، والتي ثبت أنها لها فوائد لفروة رأسك وشعرك.',
    'products.hydratingShampoo.description': 'Ищете увлажняющий шампунь, который может укрепить ваши пряди, не утяжеляя волосы. Этот увлажняющий шампунь для ежедневного ухода, насыщенный богатым антиоксидантами аргановым маслом и восстанавливающими питательными веществами для утоления и питания сухих волос. Обеспечивает увлажнение для здоровых волос для ежедневного очищения и повышения влажности.',
    'products.hydratingConditioner.description': 'Интенсивно увлажняющий кондиционер. Представляем новый увлажняющий кондиционер Celine Claire Cosmetic. Этот замечательный продукт - идеальное решение для увлажнения ваших волос. Вьющиеся волосы вас раздражают? Поврежденные волосы вас огорчают? Оживите и восстановите внешний вид ваших волос с помощью этого увлажняющего кондиционера, изготовленного из арганового масла высшего качества.',
    'products.silverShampoo.description': 'Фиолетовый шампунь - это теория цвета в самом простом виде: временный оттенок делает все типы светлых и блондинистых волос похожими на свежие из салона. У Celine Claire есть новый фиолетовый шампунь, который превратит ваши желтые, медные блондинистые тона в красивый оттенок блонда снова. Независимо от того, стали ли вы платиновой блондинкой или просто хотите осветлить свой естественный оттенок, этот фиолетовый шампунь останавливает медность и оживляет ваш оттенок всего за одно мытье.',
    'products.purpleRepairMask.description': 'Having blonde hair is never easy for your time or wallet. Blonde hair whether you are born with it or it comes at the expense of your stylist requires a lot of work. Celine Claire Cosmetic introduces a brand-new product that aims to make having luscious blonde locks. When we rely on pricey in-salon color treatments to maintain the blonde tresses we need to do upkeep at home. To solve this issue of upkeep in between touch-ups, Celine Claire presents the Celine Claire Purple Repair Mask. This mask is the perfect product to help you in your battle with brassiness. The deep purple tones out the orange and copper tones that develop on blonde hair. Why does this happen? Brassiness can happen due to several factors, such as UV exposure, hard water damage, or chlorine in swimming pools. Our Purple Repair Mask treats unwanted brass warm tones without you having to step foot inside a hair salon. Celine Claire has one of the best complete hair care systems dedicated to blonde hair. Start your blonde hair care journey by washing your luscious locks with the Celine Claire Purple Shampoo once or twice a week. This will depend on how often you shampoo your hair. Follow up on the Celine Claire Purple Repair Mask. This moisturizing product is rich in Argan oil that helps the hair repair damage and remains silky soft. This hair care system is essential for maintaining your blonde color. The repair mask is very rich and is the perfect solution to over-processed and damaged blonde hair.',
    'products.hairMask.description': 'Mascara for hair that intensively moisturizes and conditions damaged hair, restores moisture, and leaves hair silky smooth.',
    'products.hairEnhancementShampoo.description': 'Professional-grade shampoo that strengthens and enhances hair health with advanced formula.',
    'products.volumiserShampoo.description': 'Shampoo that adds volume and body to fine, flat hair without weighing it down.',
    'products.volumiserConditioner.description': 'Lightweight conditioning that complements the volumiser shampoo and maintains volume and adds shine.',
    'products.cck1And2.description': 'Professional keratin treatment system for salon-quality smoothing and frizz control.',
    'products.cck3.description': 'Sulfate-free daily shampoo specially formulated to maintain and extend keratin treatments.',
    'products.cck4.description': 'Nourishing daily conditioner that preserves keratin treatments while adding moisture and shine.',
    'products.aquaStylingWax.description': 'Water-based styling wax that provides flexible hold and texture with a natural finish.',
    'products.deadSeaSaltSpray.description': 'Texturizing spray with Dead Sea minerals that creates beachy waves and adds volume.',
    'products.heatShieldSpray.description': 'Protective spray that shields hair from heat damage up to 230°C while adding shine.',
    'products.moisturizingCream.description': 'Rich leave-in conditioning cream that provides all-day hydration and frizz control.',
    'products.curlEssence.description': 'Leave-in conditioner that defines curls and reduces frizz while enhancing natural curl pattern.',
    'products.tecplexKits.description': 'Professional bond-building treatment system that repairs and strengthens damaged hair.',
    'products.tecplexNo3.description': 'At-home hair perfector that rebuilds broken bonds and improves hair strength.',
    'products.tecplexNo7.description': 'Lightweight bonding oil that adds brilliant shine while repairing and protecting hair.',
    'products.flexyBrush.description': 'Flexible detangling brush with soft bristles that glides through wet or dry hair without pulling.',
    'products.flexyBrushSet.description': 'Professional set of 4 flexible detangling brushes for complete hair care - perfect for salons and families.',

    // Cart
    'cart.empty': 'سلتك فارغة',
    'cart.checkout': 'إتمام الشراء',
    'cart.subtotal': 'المجموع الفرعي',
    'cart.shipping': 'الشحن',
    'cart.tax': 'الضريبة',

    // Auth
    'auth.login': 'تسجيل الدخول',
    'auth.register': 'إنشاء حساب',
    'auth.logout': 'تسجيل الخروج',
    'auth.email': 'البريد الإلكتروني',
    'auth.password': 'كلمة المرور',
    'auth.forgotPassword': 'نسيت كلمة المرور؟',
    'auth.emailAddress': 'عنوان البريد الإلكتروني',
    'auth.enterEmail': 'أدخل عنوان بريدك الإلكتروني',
    'auth.enterPassword': 'أدخل كلمة المرور',
    'auth.rememberMe': 'تذكرني',
    'auth.signingIn': 'جاري تسجيل الدخول...',
    'auth.signIn': 'ورود',
    'auth.orContinueWith': 'یا ادامه با',
    'auth.google': 'جوجل',
    'auth.facebook': 'فیسبوک',
    'auth.loginAs': 'ورود به عنوان',
    'auth.registerAs': 'ثبت‌نام به عنوان',
    'auth.onlineCustomer': 'مشتری آنلاین',
    'auth.salonStore': 'سالن یا فروشگاه',
    'auth.salesRepresentative': 'نماینده فروش',
    'auth.management': 'مدیریت',
    'auth.admin': 'مدیر',
    'auth.fullName': 'نام کامل',
    'auth.enterFullName': 'أدخل اسمك الكامل',
    'auth.confirmPassword': 'تأكيد كلمة المرور',
    'auth.phoneNumber': 'رقم الهاتف',
    'auth.enterPhoneNumber': 'أدخل رقم هاتفك',
    'auth.whatsappNumber': 'رقم الواتساب',
    'auth.enterWhatsappNumber': 'أدخل رقم الواتساب الخاص بك',
    'auth.addressInformation': 'اطلاعات آدرس',
    'auth.street': 'آدرس خیابان',
    'auth.enterStreetAddress': 'أدخل عنوان الشارع',
    'auth.city': 'المدينة',
    'auth.enterCity': 'أدخل مدينتك',
    'auth.emirateOrState': 'الإمارة أو الولاية',
    'auth.enterEmirateOrState': 'أدخل الإمارة أو الولاية',
    'auth.country': 'الدولة',
    'auth.enterCountry': 'أدخل بلدك',
    'auth.zipCode': 'الرمز البريدي',
    'auth.enterZipCode': 'أدخل الرمز البريدي',
    'auth.agreeToTerms': 'أوافق على الشروط والأحكام',
    'auth.receivePromotions': 'دریافت ایمیل‌های تبلیغاتی',
    'auth.receiveRecommendations': 'دریافت توصیه‌های محصول',
    'auth.creating': 'جاري إنشاء الحساب...',
    'auth.createAccount': 'إنشاء حساب',
    'auth.welcomeBack': 'مرحبًا، من الجميل رؤيتك قادمًا!',
    'auth.welcomeBackDesc': 'بیا، وارد شو!\n\nیا، اگر برای اولین بار اینجا هستی، لطفاً ثبت‌نام کن.',
    'auth.createYourAccount': 'Create Your Account',
    'auth.createYourAccountDesc': 'Join CosmeticStore and start your personalized beauty journey today',
    'auth.signInTab': 'Sign In',
    'auth.createAccountTab': 'Create Account',
    'auth.dontHaveAccount': 'حساب ندارید؟',
    'auth.signUpNow': 'اکنون ثبت‌نام کنید',
    'auth.alreadyHaveAccount': 'از قبل حساب دارید؟',
    'auth.needHelp': 'به کمک نیاز دارید؟',
    'auth.liveChatSupport': 'پشتیبانی چت زنده',
    'auth.available247': 'در دسترس 24/7',
    'auth.emailSupport': 'پشتیبانی ایمیل',
    'auth.phoneSupport': 'پشتیبانی تلفنی',
    'auth.yourSecurityMatters': 'امنیت شما مهم است',
    'auth.secureAuthentication': 'احراز هویت ایمن',
    'auth.secureAuthDesc': 'داده‌های شما با رمزگذاری استاندارد صنعت محافظت می‌شوند',
    'auth.privacyProtected': 'حریم خصوصی محافظت شده',
    'auth.privacyProtectedDesc': 'ما هرگز اطلاعات شخصی شما را با اشخاص ثالث به اشتراک نمی‌گذاریم',
    'auth.verifiedSecure': 'Проверено безопасно',
    'auth.verifiedSecureDesc': 'SSL-сертифицирован и PCI-совместим для безопасных транзакций',
    'auth.continueAsGuest': 'ادامه به عنوان مهمان',
    'auth.continueAsGuestDesc': 'Вы можете оформить заказ без создания аккаунта, но вы упустите эти преимущества:',
    'auth.exclusiveRewards': 'Эксклюзивные награды',
    'auth.exclusiveRewardsDesc': 'Зарабатывайте баллы за каждую покупку и получайте специальные скидки',
    'auth.fasterCheckout': 'Быстрая оплата',
    'auth.fasterCheckoutDesc': 'Сохраните свои данные для быстрого и легкого оформления заказа в будущем',
    'auth.orderTracking': 'Отслеживание заказов',
    'auth.orderTrackingDesc': 'Отслеживайте ваши отправки и просматривайте весь журнал заказов',
    'auth.personalizedExperience': 'Персонализированный опыт',
    'auth.personalizedExperienceDesc': 'Получайте рекомендации по продуктам, адаптированные к вашим предпочтениям',
    'auth.createAccountAfter': 'Вы можете создать аккаунт после оформления заказа',
    'auth.forgotPasswordTitle': 'Forgot Password?',
    'auth.forgotPasswordDesc': 'Enter your email address and we\'ll send you a link to reset your password',
    'auth.sendResetLink': 'Send Reset Link',
    'auth.sending': 'Sending...',
    'auth.checkYourEmail': 'Check Your Email',
    'auth.checkYourEmailDesc': 'We\'ve sent a password reset link to',
    'auth.checkYourEmailDesc2': 'Please check your inbox and follow the instructions.',
    'auth.didntReceiveEmail': 'Didn\'t receive the email? Check your spam folder or try again in a few minutes.',

    // Privacy Policy (legacy keys)
    'privacy.title': 'Политика конфиденциальности',
    'privacy.companyName': 'Селин Клер Косметик',
    'privacy.lastUpdated': 'Последнее обновление',
    'privacy.tableOfContents': 'Содержание',
    'privacy.printPolicy': 'Печать политики',
    'privacy.introduction': 'Введение',
    'privacy.introText': 'Celine Claire Cosmetic ("мы", "нас", "наша") стремится защитить вашу конфиденциальность и обеспечить безопасный и приятный опыт покупок. Эта Политика конфиденциальности объясняет, как мы собираем, используем и защищаем вашу личную информацию, когда вы посещаете наш веб-сайт, используете наши услуги или совершаете покупки у нас.',
    'privacy.yourRights': 'Ваши права',
    'privacy.yourRightsText': 'Вы имеете право на доступ, исправление или удаление вашей личной информации. Вы также имеете право подать жалобу, если считаете, что ваши права на конфиденциальность были нарушены.',
    'privacy.dataCollection': 'Сбор данных',
    'privacy.dataUsage': 'Использование данных',
    'privacy.dataProtection': 'Защита данных',
    'privacy.thirdParties': 'Передача третьим лицам',
    'privacy.retention': 'Хранение данных',
    'privacy.yourChoices': 'Ваш выбор',
    'privacy.contactUs': 'Свяжитесь с нами',
    'privacy.backToShopping': 'Вернуться к покупкам',

    // Filters
    'filters.filters': 'فیلترها',
    'filters.clearAll': 'Очистить все',
    'filters.results': 'Результаты',
    'filters.categories': 'Категории',
    'filters.allProducts': 'Все продукты',
    'filters.skincare': 'Медицинский уход',
    'filters.makeup': 'Макияж',
    'filters.fragrance': 'Ароматика',
    'filters.haircare': 'Уход за волосами',
    'filters.priceRange': 'Диапазон цен',
    'filters.brands': 'Бренды',
    'filters.skinType': 'Тип кожи',
    'filters.normal': 'Нормальная',
    'filters.dry': 'Жирная',
    'filters.oily': 'Масляная',
    'filters.combination': 'Смешанная',
    'filters.sensitive': 'Чувствительная',

    // Sort
    'sort.sortBy': 'Сортировка по:',
    'sort.relevance': 'Связанность',
    'sort.priceLowToHigh': 'Цена: от низкой к высокой',
    'sort.priceHighToLow': 'Цена: от высокой к низкой',
    'sort.highestRated': 'Наибольший рейтинг',
    'sort.newestFirst': 'Сначала новые',

    // Currency
    'currency.amount': 'Сумма',
    'currency.enterAmount': 'Введите сумму',
    'currency.fromCurrency': 'Из валюты',
    'currency.convertedAmounts': 'Преобразованные суммы:',

    // Celine Home Modal
    'celine.modalMessage': 'You are on the way to visit the Celine Claire Cosmetics Home site .... Are you sure you want to leave the Celine Claire Store?',
    'celine.modalSubtext': '... the Celine Home will open in a new window, you can always come back here ... enjoy your journey!',
    'celine.home': 'CELINE Home',
    'celine.cart': 'CART',
    'celine.login': 'LOGIN',

    // Shopping Cart
    'cart.title': 'سبد خرید',
    'cart.item': 'مورد',
    'cart.items': 'موارد',
    'cart.inYourCart': 'در سبد شما',
    'cart.yourCartIsEmpty': 'سبد خرید شما خالی است',
    'cart.emptyCartMessage': 'به نظر می‌رسد هنوز هیچ محصول زیبایی اضافه نکرده‌اید. برای پر کردن سبد خرید شروع به خرید کنید!',
    'cart.startShopping': 'شروع خرید',
    'cart.shopByCategory': 'خرید بر اساس دسته‌بندی',
    'cart.youMightLike': 'ممکن است دوست داشته باشید',
    'cart.orderSummary': 'خلاصه سفارش',
    'cart.estimatedTax': 'مالیات تخمینی',
    'cart.free': 'رایگان',
    'cart.proceedToCheckout': 'ادامه به پرداخت',
    'cart.continueShopping': 'ادامه خرید',
    'cart.freeShipping': 'ارسال رایگان',
    'cart.freeShippingDesc': 'برای سفارشات بالای 50 دلار',
    'cart.securePayment': 'پرداخت ایمن',
    'cart.securePaymentDesc': 'پرداخت رمزگذاری شده SSL',
    'cart.easyReturns': 'بازگشت آسان',
    'cart.easyReturnsDesc': 'سیاست بازگشت 30 روزه',
    'cart.promoCode': 'کد تبلیغاتی',
    'cart.codeApplied': 'کد اعمال شد',
    'cart.enterPromoCode': 'کد تبلیغاتی را وارد کنید',
    'cart.apply': 'اعمال',
    'cart.pleaseEnterPromoCode': 'لطفاً کد تبلیغاتی را وارد کنید',
    'cart.availableCodes': 'کدهای موجود:',
    'cart.variant': 'نوع',
    'cart.save': 'ذخیره',
    'cart.saveForLater': 'ذخیره برای بعد',
    'cart.remove': 'حذف',
    'cart.estimatedDelivery': 'تحویل تخمینی',
    'cart.itemTotal': 'مجموع مورد:',
    'cart.discount': 'تخفیف',

    // Dashboard
    'dashboard.loadingDashboard': 'در حال بارگذاری داشبورد...',
    'dashboard.quickActions': 'اقدامات سریع',
    'dashboard.recentOrders': 'سفارشات اخیر',
    'dashboard.admin.topSellingProducts': 'محصولات پرفروش',
    'dashboard.admin.systemAlerts': 'هشدارهای سیستم',
    'dashboard.management.inventoryAlerts': 'هشدارهای موجودی',
    'dashboard.management.topCategories': 'دسته‌بندی‌های برتر',
    'dashboard.management.salesTeamPerformance': 'عملکرد تیم فروش',
    'dashboard.sales.leadPipeline': 'خط لوله سرنخ',
    'dashboard.sales.recentInteractions': 'تعاملات اخیر',
    'dashboard.sales.yourTopProducts': 'محصولات برتر شما',
    'dashboard.mobileSales.recentClients': 'مشتریان اخیر',
    'dashboard.mobileSales.sampleInventory': 'موجودی نمونه',
    'dashboard.mobileSales.commissionBreakdown': 'تفکیک العمولة',
    'dashboard.mobileSales.clientVisitLogs': 'گزارش بازدید مشتری',
    'dashboard.analytics.analyticsPeriod': 'دوره تحلیل',
    'dashboard.analytics.selectTimeRange': 'Select time range for data analysis',
    'dashboard.analytics.3months': '3 ماه',
    'dashboard.analytics.6months': '6 ماه',
    'dashboard.analytics.12months': '12 ماه',
    'dashboard.analytics.quickReports': 'گزارش‌های سریع',
    'dashboard.realtime.autoRefreshOn': 'به‌روزرسانی خودکار روشن',
    'dashboard.realtime.autoRefreshOff': 'به‌روزرسانی خودکار خاموش',
    'dashboard.realtime.lastUpdated': 'آخرین به‌روزرسانی',
    'dashboard.reports.reportTemplates': 'قالب‌های گزارش',
    'dashboard.reports.customReportBuilder': 'سازنده گزارش سفارشی',
    'dashboard.reports.reportHistory': 'تاریخچه گزارش',
    'dashboard.reports.preBuiltTemplates': 'قالب‌های از پیش ساخته شده',
    'dashboard.reports.selectTemplate': 'Select a template for quick report generation',
    'dashboard.reports.accessPreviousReports': 'دسترسی به گزارش‌های قبلی',
    'dashboard.salon.overview': 'نمای کلی',
    'dashboard.salon.invoices': 'فاکتورها',
    'dashboard.salon.paymentHistory': 'تاریخچه پرداخت',
    'dashboard.salon.appointments': 'قرارها',
    'dashboard.salon.inventory': 'موجودی',
    'dashboard.salon.pricingTier': 'سطح قیمت‌گذاری',
    'dashboard.salon.creditLimit': 'حد اعتبار',
    'dashboard.salon.currentBalance': 'موجودی فعلی',
    'dashboard.salon.paymentTerms': 'شرایط پرداخت',
  },
  fa: {
    // Navigation
    'nav.shop': 'فروشگاه',
    'nav.cart': 'سبد خرید من',
    'nav.account': 'حساب من',
    'nav.dashboard': 'داشبورد',
    'nav.products': 'محصولات',
    'nav.orders': 'سفارشات',

    // Hamburger Menu
    'menu.home': 'خانه',
    'menu.categories': 'دسته‌بندی‌ها',
    'menu.brands': 'برندها',
    'menu.newArrivals': 'تازه‌ها',
    'menu.sale': 'حراج',
    'menu.aboutUs': 'درباره ما',
    'menu.contact': 'تماس',
    'menu.privacyPolicy': 'سیاست حفظ حریم خصوصی',
    'menu.termsConditions': 'شرایط و ضوابط',

    // Common
    'common.search': 'جستجو',
    'common.searchPlaceholder': 'برای جستجو تایپ کنید',
    'common.filter': 'فیلتر',
    'common.filters': 'فیلترها',
    'common.sort': 'مرتب‌سازی',
    'common.add': 'افزودن',
    'common.edit': 'ویرایش',
    'common.delete': 'حذف',
    'common.save': 'ذخیره',
    'common.cancel': 'لغو',
    'common.close': 'بستن',
    'common.loading': 'در حال بارگذاری...',
    'common.price': 'قیمت',
    'common.quantity': 'تعداد',
    'common.total': 'مجموع',
    'common.clearAllFilters': 'پاک کردن همه فیلترها',
    'common.noProductsFound': 'محصولی یافت نشد',
    'common.adjustFilters': 'فیلترها یا جستجوی خود را تنظیم کنید',

    // Product Catalog
    'catalog.welcome': 'خوش آمدید!',
    'catalog.description': 'مجموعه منتخب ما از محصولات زیبایی ممتاز را کشف کنید',
    'catalog.gridView': 'نمای شبکه‌ای',
    'catalog.listView': 'نمای لیستی',
    'catalog.addedToCart': 'محصول با موفقیت به سبد خرید اضافه شد!',
    'catalog.brandName': 'Celine Claire',
    'catalog.tagline': 'for Unique, Unmatched, Lasting Results',
    'catalog.callToAction': 'YOU MUST TRY IT TO BELIEVE IT!',
    'catalog.uniqueTitle': 'Celine Claire is Unique',
    'catalog.uniqueSubtitle': 'unlike any other',
    'catalog.uniqueAction': 'learn why',
    'catalog.expertTitle': 'Celine Claire is Expert',
    'catalog.expertSubtitle': 'get best advice',
    'catalog.expertAction': 'Learn how',
    'catalog.caresTitle': 'Celine Claire Cares',
    'catalog.caresSubtitle': 'seek medical help',
    'catalog.caresAction': 'Get healthy!',

    // Expert Modal - Holistic Hair Care (Persian)
    'expert.modal.title': 'مشاوره تخصصی سلین کلر',
    'expert.modal.intro': 'رویکرد جامع سلین کلر را برای مراقبت از مو بپذیرید تا پتانسیل واقعی موهای خود را آزاد کنید!',
    'expert.modal.paragraph1': 'این تست طراحی شده با دقت به شما کمک می‌کند نه تنها بهترین محصول مناسب برای نیازهای خاص خود را انتخاب کنید، بلکه راه‌حل‌های تخصصی را ارائه دهد که فراتر از هزینه‌های آرایشی زیبایی است!',
    'expert.modal.paragraph2': 'در سلین، ما درک می‌کنیم که موهای شما بیش از یک بیانیه سبک است؛ این بازتابی از سلامت کلی، سبک زندگی و حتی وضعیت عاطفی یا روانی شماست.',
    'expert.modal.paragraph3': 'ما می‌خواهیم به شما کمک کنیم بفهمید که عواملی مانند سطح استرس، رژیم غذایی، روال روزانه و حتی محیط شما نقش مهمی در سلامت موها و پوست سر شما دارند.',
    'expert.modal.paragraph4': 'در حالی که محصولات ما به خاطر عملکرد منحصر به فرد و نتایج ماندگار شناخته شده و مورد تحسین قرار می‌گیرند، ما متعهد هستیم که بیش از کیفیت لوکس به شما ارائه دهیم.',
    'expert.modal.paragraph5': 'ما می‌خواهیم شما را با دانش در مورد عوامل مختلف تأثیرگذار بر سلامت موهایتان حمایت کنیم تا بتوانید بهترین نتایج ممکن را به دست آورید، نه فقط در محصولاتی که سطح را درمان می‌کنند سرمایه‌گذاری کنید.',
    'expert.modal.toggleTitle': 'برای مشاهده عوامل اساسی اینجا کلیک کنید',
    'expert.modal.factor1.title': '**سطح استرس:**',
    'expert.modal.factor1.content': 'استرس بالا می‌تواند منجر به نازک شدن و ریزش مو شود. مدیریت استرس از طریق تمرینات ذهن‌آگاهی، ورزش و خواب مناسب می‌تواند پوست سر و فولیکول‌های سالم‌تری را ترویج دهد.',
    'expert.modal.factor2.title': '**رژیم غذایی:**',
    'expert.modal.factor2.content': 'یک رژیم غذایی متعادل غنی از ویتامین‌ها و مواد معدنی ضروری است. غذاهای غنی از امگا-3، ویتامین‌های A، C، D و E، همراه با روی و آهن، به موهای قوی‌تر و درخشان‌تر کمک می‌کنند. در نظر بگیرید که غذاهای غنی از مواد مغذی را برای تغذیه موهایتان از درون وارد کنید.',
    'expert.modal.factor3.title': '**روال روزانه:**',
    'expert.modal.factor3.content': 'عادات روزانه شما باید از سلامت موهایتان حمایت کند. پاکسازی ملایم، نرم‌کننده و به حداقل رساندن استایل حرارتی می‌تواند منجر به موهای قوی‌تر و انعطاف‌پذیرتر شود. روال‌هایی ایجاد کنید که پوست سر شما را نوازش کرده و رشد مو را ترویج دهند.',
    'expert.modal.factor4.title': '**انتخاب‌های سبک زندگی:**',
    'expert.modal.factor4.content': 'Живете ли вы в оживленном городском центре или в тихой деревне, ваш образ жизни влияет на состояние ваших волос. Горные среды могут подвергать ваши волосы загрязнению; следовательно, безопасные меры, такие как регулярное очищение и использование средств с антисептическими добавками, могут помочь снизить вред. В сельской местности такие факторы, как влажность и воздействие солнца, требуют индивидуального ухода для оптимального здоровья волос.',
    'expert.modal.factor5.title': '**ملاحظات آب و هوایی:**',
    'expert.modal.factor5.content': 'آب و هوای مختلف می‌تواند بر سطح رطوبة و قدرت موهای شما تأثیر بگذارد. Адаптация вашего режима ухода за волосами для включения увлажняющих средств в сухом климате и защитных стилей во влажных областях обеспечит вам сохранение роскошных локонов круглый год.',
    'expert.modal.paragraph6': 'Allow us to uncover and address all possible underlying issues together, and responsibly ensure, restore and maintain your hair\'s beauty and vitality.',
    'expert.modal.paragraph7': 'Take control of your hair health, click on the button below and undertake our TEST and explore our range of expert solutions that go beyond beauty. Visit our website today to discover how Celine can elevate your hair care routine and enhance your overall well-being. Your journey to healthier hair starts now!',
    'expert.modal.paragraph8': 'In your Test Result page, you may also receive our "SURPRISE GIFT"!',
    'expert.modal.buttonText': 'Take your Hair and Well-being Assessment Test now',

    // Product
    'product.addToCart': 'افزودن به سبد',
    'product.outOfStock': 'ناموجود',
    'product.inStock': 'موجود',
    'product.details': 'Детали продукта',
    'product.reviews': 'Отзывы',
    'product.description': 'Описание',

    // Product Names
    'products.arganOil.name': 'Аргановое масло',
    'products.hairMask.name': 'Маска для волос',
    'products.purpleRepairMask.name': 'Фиолетовая восстанавливающая маска',
    'products.hairEnhancementShampoo.name': 'Шампунь для улучшения волос',
    'products.volumiserShampoo.name': 'Шампунь для объема',
    'products.volumiserConditioner.name': 'Кондиционер для объема',
    'products.hydratingShampoo.name': 'Увлажняющий шампунь',
    'products.hydratingConditioner.name': 'Увлажняющий кондиционер',
    'products.cck1And2.name': 'Набор очищающего шампуня и кератина CCK1 и 2',
    'products.cck3.name': 'Ежедневный кератиновый шампунь CCK3',
    'products.cck4.name': 'Ежедневный кератиновый кондиционер CCK4',
    'products.aquaStylingWax.name': 'Воск для укладки волос Aqua',
    'products.deadSeaSaltSpray.name': 'Спрей с солью Мертвого моря',
    'products.heatShieldSpray.name': 'Спрей для защиты от тепла',
    'products.moisturizingCream.name': 'Крем мартобный кондиционер без смывания',
    'products.curlEssence.name': 'Кондиционер для локонов без смывания',
    'products.tecplexKits.name': 'Киоти профессиональные системы построения связи',
    'products.tecplexNo3.name': 'TecPlex No.3',
    'products.tecplexNo7.name': 'TecPlex No7 Oil',
    'products.silverShampoo.name': 'Шампунь серебряный',
    'products.flexyBrush.name': 'Гибкая щетка для волос',
    'products.flexyBrushSet.name': 'Профессиональный набор гибких щеток (4 шт.)',

    // Product Descriptions
    'products.arganOil.description': 'Что такое аргановое масло? Аргановое масло - или "жидкое золото", как многие его называют - изготавливается из свежих ядер плодов арганового дерева в Марокко. Чистое аргановое масло использовалось веками для приготовления пищи и в качестве домашнего средства для здоровья и красоты, включая выпадение волос. Сегодня его можно найти в ряде средств по уходу за волосами и кожей, включая марокканское аргановое масло Celine Claire.',
    'products.hydratingShampoo.description': 'Ищете увлажняющий шампунь, который может укрепить ваши пряди, не утяжеляя волосы. Этот увлажняющий шампунь для ежедневного ухода, насыщенный богатым антиоксидантами аргановым маслом и восстанавливающими питательными веществами для утоления и питания сухих волос. Обеспечивает увлажнение для здоровых волос для ежедневного очищения и повышения влажности.',
    'products.hydratingConditioner.description': 'Интенсивно увлажняющий кондиционер. Представляем новый увлажняющий кондиционер Celine Claire Cosmetic. Этот замечательный продукт - идеальное решение для увлажнения ваших волос. Вьющиеся волосы вас раздражают? Поврежденные волосы вас огорчают? Оживите и восстановите внешний вид ваших волос с помощью этого увлажняющего кондиционера, изготовленного из арганового масла высшего качества.',
    'products.silverShampoo.description': 'Фиолетовый шампунь - это теория цвета в самом простом виде: временный оттенок делает все типы светлых и блондинистых волос похожими на свежие из салона. У Celine Claire есть новый фиолетовый шампунь, который превратит ваши желтые, медные блондинистые тона в красивый оттенок блонда снова. Независимо от того, стали ли вы платиновой блондинкой или просто хотите осветлить свой естественный оттенок, этот фиолетовый шампунь останавливает медность и оживляет ваш оттенок всего за одно мытье.',
    'products.purpleRepairMask.description': 'Having blonde hair is never easy for your time or wallet. Blonde hair whether you are born with it or it comes at the expense of your stylist requires a lot of work. Celine Claire Cosmetic introduces a brand-new product that aims to make having luscious blonde locks. When we rely on pricey in-salon color treatments to maintain the blonde tresses we need to do upkeep at home. To solve this issue of upkeep in between touch-ups, Celine Claire presents the Celine Claire Purple Repair Mask. This mask is the perfect product to help you in your battle with brassiness. The deep purple tones out the orange and copper tones that develop on blonde hair. Why does this happen? Brassiness can happen due to several factors, such as UV exposure, hard water damage, or chlorine in swimming pools. Our Purple Repair Mask treats unwanted brass warm tones without you having to step foot inside a hair salon. Celine Claire has one of the best complete hair care systems dedicated to blonde hair. Start your blonde hair care journey by washing your luscious locks with the Celine Claire Purple Shampoo once or twice a week. This will depend on how often you shampoo your hair. Follow up on the Celine Claire Purple Repair Mask. This moisturizing product is rich in Argan oil that helps the hair repair damage and remains silky soft. This hair care system is essential for maintaining your blonde color. The repair mask is very rich and is the perfect solution to over-processed and damaged blonde hair.',
    'products.hairMask.description': 'Mascara for hair that intensively moisturizes and conditions damaged hair, restores moisture, and leaves hair silky smooth.',
    'products.hairEnhancementShampoo.description': 'Professional-grade shampoo that strengthens and enhances hair health with advanced formula.',
    'products.volumiserShampoo.description': 'Shampoo that adds volume and body to fine, flat hair without weighing it down.',
    'products.volumiserConditioner.description': 'Lightweight conditioning that complements the volumiser shampoo and maintains volume and adds shine.',
    'products.cck1And2.description': 'Professional keratin treatment system for salon-quality smoothing and frizz control.',
    'products.cck3.description': 'Sulfate-free daily shampoo specially formulated to maintain and extend keratin treatments.',
    'products.cck4.description': 'Nourishing daily conditioner that preserves keratin treatments while adding moisture and shine.',
    'products.aquaStylingWax.description': 'Water-based styling wax that provides flexible hold and texture with a natural finish.',
    'products.deadSeaSaltSpray.description': 'Texturizing spray with Dead Sea minerals that creates beachy waves and adds volume.',
    'products.heatShieldSpray.description': 'Protective spray that shields hair from heat damage up to 230°C while adding shine.',
    'products.moisturizingCream.description': 'Rich leave-in conditioning cream that provides all-day hydration and frizz control.',
    'products.curlEssence.description': 'Leave-in conditioner that defines curls and reduces frizz while enhancing natural curl pattern.',
    'products.tecplexKits.description': 'Professional bond-building treatment system that repairs and strengthens damaged hair.',
    'products.tecplexNo3.description': 'At-home hair perfector that rebuilds broken bonds and improves hair strength.',
    'products.tecplexNo7.description': 'Lightweight bonding oil that adds brilliant shine while repairing and protecting hair.',
    'products.flexyBrush.description': 'Flexible detangling brush with soft bristles that glides through wet or dry hair without pulling.',
    'products.flexyBrushSet.description': 'Professional set of 4 flexible detangling brushes for complete hair care - perfect for salons and families.',

    // Cart
    'cart.empty': 'Ваша корзина пуста',
    'cart.checkout': 'Оформить заказ',
    'cart.subtotal': 'Промежуточный итог',
    'cart.shipping': 'Доставка',
    'cart.tax': 'Налог',

    // Auth
    'auth.login': 'Войти',
    'auth.register': 'Регистрация',
    'auth.logout': 'Выйти',
    'auth.email': 'Электронная почта',
    'auth.password': 'Пароль',
    'auth.forgotPassword': 'Забыли пароль?',
    'auth.emailAddress': 'Адрес электронной почты',
    'auth.enterEmail': 'Введите ваш адрес электронной почты',
    'auth.enterPassword': 'Введите ваш пароль',
    'auth.rememberMe': 'Запомнить меня',
    'auth.signingIn': 'Вход...',
    'auth.signIn': 'Войти',
    'auth.orContinueWith': 'Или продолжить с',
    'auth.google': 'Google',
    'auth.facebook': 'Facebook',
    'auth.loginAs': 'Войти как',
    'auth.registerAs': 'Зарегистрироваться как',
    'auth.onlineCustomer': 'Онлайн-клиент',
    'auth.salonStore': 'Салон или магазин',
    'auth.salesRepresentative': 'Торговый представитель',
    'auth.management': 'Управление',
    'auth.admin': 'Администратор',
    'auth.fullName': 'Полное имя',
    'auth.enterFullName': 'Введите ваше полное имя',
    'auth.confirmPassword': 'Подтвердите пароль',
    'auth.phoneNumber': 'Номер телефона',
    'auth.enterPhoneNumber': 'Введите ваш номер телефона',
    'auth.whatsappNumber': 'Номер WhatsApp',
    'auth.enterWhatsappNumber': 'Введите ваш номер WhatsApp',
    'auth.addressInformation': 'Информация об адресе',
    'auth.street': 'Адрес улицы',
    'auth.enterStreetAddress': 'Введите адрес улицы',
    'auth.city': 'Город',
    'auth.enterCity': 'Введите ваш город',
    'auth.emirateOrState': 'Эмират или штат',
    'auth.enterEmirateOrState': 'Введите ваш эмират или штат',
    'auth.country': 'Страна',
    'auth.enterCountry': 'Введите вашу страну',
    'auth.zipCode': 'Почтовый индекс',
    'auth.enterZipCode': 'Введите ваш почтовый индекс',
    'auth.agreeToTerms': 'Я согласен с условиями и положениями',
    'auth.receivePromotions': 'Получать рекламные письма',
    'auth.receiveRecommendations': 'Получать рекомендации по продуктам',
    'auth.creating': 'Создание аккаунта...',
    'auth.createAccount': 'Создать аккаунт',
    'auth.welcomeBack': 'Привет, рады видеть тебя!',
    'auth.welcomeBackDesc': 'Давай, заходи!\n\nИли, если ты здесь впервые, пожалуйста, зарегистрируйся.',
    'auth.createYourAccount': 'Create Your Account',
    'auth.createYourAccountDesc': 'Join CosmeticStore and start your personalized beauty journey today',
    'auth.signInTab': 'Sign In',
    'auth.createAccountTab': 'Create Account',
    'auth.dontHaveAccount': 'Нет аккаунта?',
    'auth.signUpNow': 'Зарегистрируйтесь сейчас',
    'auth.alreadyHaveAccount': 'Уже есть аккаунт?',
    'auth.needHelp': 'Нужна помощь?',
    'auth.liveChatSupport': 'Помощь в чате',
    'auth.available247': 'Доступно 24/7',
    'auth.emailSupport': 'Помощь по электронной почте',
    'auth.phoneSupport': 'Телефонная помощь',
    'auth.yourSecurityMatters': 'Ваша безопасность важна',
    'auth.secureAuthentication': 'Безопасная аутентификация',
    'auth.secureAuthDesc': 'Ваши данные защищены шифрованием промышленного стандарта',
    'auth.privacyProtected': 'Конфиденциальность защищена',
    'auth.privacyProtectedDesc': 'Мы никогда не передаем вашу личную информацию третьим лицам',
    'auth.verifiedSecure': 'Проверено безопасно',
    'auth.verifiedSecureDesc': 'SSL-сертифицирован и PCI-совместим для безопасных транзакций',
    'auth.continueAsGuest': 'Продолжить как гость',
    'auth.continueAsGuestDesc': 'Вы можете оформить заказ без создания аккаунта, но вы упустите эти преимущества:',
    'auth.exclusiveRewards': 'Эксклюзивные награды',
    'auth.exclusiveRewardsDesc': 'Зарабатывайте баллы за каждую покупку и получайте специальные скидки',
    'auth.fasterCheckout': 'Быстрая оплата',
    'auth.fasterCheckoutDesc': 'Сохраните свои данные для быстрого и легкого оформления заказа в будущем',
    'auth.orderTracking': 'Отслеживание заказов',
    'auth.orderTrackingDesc': 'Отслеживайте ваши отправки и просматривайте весь журнал заказов',
    'auth.personalizedExperience': 'Персонализированный опыт',
    'auth.personalizedExperienceDesc': 'Получайте рекомендации по продуктам, адаптированные к вашим предпочтениям',
    'auth.createAccountAfter': 'Вы можете создать аккаунт после оформления заказа',
    'auth.forgotPasswordTitle': 'Forgot Password?',
    'auth.forgotPasswordDesc': 'Enter your email address and we\'ll send you a link to reset your password',
    'auth.sendResetLink': 'Send Reset Link',
    'auth.sending': 'Sending...',
    'auth.checkYourEmail': 'Check Your Email',
    'auth.checkYourEmailDesc': 'We\'ve sent a password reset link to',
    'auth.checkYourEmailDesc2': 'Please check your inbox and follow the instructions.',
    'auth.didntReceiveEmail': 'Didn\'t receive the email? Check your spam folder or try again in a few minutes.',

    // Privacy Policy (legacy keys)
    'privacy.title': 'Политика конфиденциальности',
    'privacy.companyName': 'Селин Клер Косметик',
    'privacy.lastUpdated': 'Последнее обновление',
    'privacy.tableOfContents': 'Содержание',
    'privacy.printPolicy': 'Печать политики',
    'privacy.introduction': 'Введение',
    'privacy.introText': 'Celine Claire Cosmetic ("мы", "нас", "наша") стремится защитить вашу конфиденциальность и обеспечить безопасный и приятный опыт покупок. Эта Политика конфиденциальности объясняет, как мы собираем, используем и защищаем вашу личную информацию, когда вы посещаете наш веб-сайт, используете наши услуги или совершаете покупки у нас.',
    'privacy.yourRights': 'Ваши права',
    'privacy.yourRightsText': 'Вы имеете право на доступ, исправление или удаление вашей личной информации. Вы также имеете право подать жалобу, если считаете, что ваши права на конфиденциальность были нарушены.',
    'privacy.dataCollection': 'Сбор данных',
    'privacy.dataUsage': 'Использование данных',
    'privacy.dataProtection': 'Защита данных',
    'privacy.thirdParties': 'Передача третьим лицам',
    'privacy.retention': 'Хранение данных',
    'privacy.yourChoices': 'Ваш выбор',
    'privacy.contactUs': 'Свяжитесь с нами',
    'privacy.backToShopping': 'Вернуться к покупкам',

    // Filters
    'filters.filters': 'Фильтры',
    'filters.clearAll': 'Очистить все',
    'filters.results': 'Результаты',
    'filters.categories': 'Категории',
    'filters.allProducts': 'Все продукты',
    'filters.skincare': 'Медицинский уход',
    'filters.makeup': 'Макияж',
    'filters.fragrance': 'Ароматика',
    'filters.haircare': 'Уход за волосами',
    'filters.priceRange': 'Диапазон цен',
    'filters.brands': 'Бренды',
    'filters.skinType': 'Тип кожи',
    'filters.normal': 'Нормальная',
    'filters.dry': 'Жирная',
    'filters.oily': 'Масляная',
    'filters.combination': 'Смешанная',
    'filters.sensitive': 'Чувствительная',

    // Sort
    'sort.sortBy': 'Сортировка по:',
    'sort.relevance': 'Связанность',
    'sort.priceLowToHigh': 'Цена: от низкой к высокой',
    'sort.priceHighToLow': 'Цена: от высокой к низкой',
    'sort.highestRated': 'Наибольший рейтинг',
    'sort.newestFirst': 'Сначала новые',

    // Currency
    'currency.amount': 'Сумма',
    'currency.enterAmount': 'Введите сумму',
    'currency.fromCurrency': 'Из валюты',
    'currency.convertedAmounts': 'Преобразованные суммы:',

    // Celine Home Modal
    'celine.modalMessage': 'You are on the way to visit the Celine Claire Cosmetics Home site .... Are you sure you want to leave the Celine Claire Store?',
    'celine.modalSubtext': '... the Celine Home will open in a new window, you can always come back here ... enjoy your journey!',
    'celine.home': 'CELINE Home',
    'celine.cart': 'CART',
    'celine.login': 'LOGIN',

    // Shopping Cart
    'cart.title': 'Shopping Cart',
    'cart.item': 'item',
    'cart.items': 'items',
    'cart.inYourCart': 'in your cart',
    'cart.yourCartIsEmpty': 'Your Cart is Empty',
    'cart.emptyCartMessage': "Looks like you haven't added any beauty products yet. Start shopping to fill your cart!",
    'cart.startShopping': 'Start Shopping',
    'cart.shopByCategory': 'Shop by Category',
    'cart.youMightLike': 'You Might Like',
    'cart.orderSummary': 'Order Summary',
    'cart.estimatedTax': 'Estimated Tax',
    'cart.free': 'FREE',
    'cart.proceedToCheckout': 'Proceed to Checkout',
    'cart.continueShopping': 'Continue Shopping',
    'cart.freeShipping': 'Free Shipping',
    'cart.freeShippingDesc': 'On orders over $50',
    'cart.securePayment': 'Secure Payment',
    'cart.securePaymentDesc': 'SSL encrypted checkout',
    'cart.easyReturns': 'Easy Returns',
    'cart.easyReturnsDesc': '30-day return policy',
    'cart.promoCode': 'Promo Code',
    'cart.codeApplied': 'Code Applied',
    'cart.enterPromoCode': 'Enter promo code',
    'cart.apply': 'Apply',
    'cart.pleaseEnterPromoCode': 'Please enter a promo code',
    'cart.availableCodes': 'Available Codes:',
    'cart.variant': 'Variant',
    'cart.save': 'Save',
    'cart.saveForLater': 'Save for Later',
    'cart.remove': 'Remove',
    'cart.estimatedDelivery': 'Estimated delivery',
    'cart.itemTotal': 'Item Total:',
    'cart.discount': 'Discount',

    // Dashboard
    'dashboard.loadingDashboard': 'Loading dashboard...',
    'dashboard.quickActions': 'Quick Actions',
    'dashboard.recentOrders': 'Recent Orders',
    'dashboard.admin.topSellingProducts': 'Top Selling Products',
    'dashboard.admin.systemAlerts': 'System Alerts',
    'dashboard.management.inventoryAlerts': 'Inventory Alerts',
    'dashboard.management.topCategories': 'Top Categories',
    'dashboard.management.salesTeamPerformance': 'Sales Team Performance',
    'dashboard.sales.leadPipeline': 'Lead Pipeline',
    'dashboard.sales.recentInteractions': 'Recent Interactions',
    'dashboard.sales.yourTopProducts': 'Your Top Products',
    'dashboard.mobileSales.recentClients': 'Recent Clients',
    'dashboard.mobileSales.sampleInventory': 'Sample Inventory',
    'dashboard.mobileSales.commissionBreakdown': 'Commission Breakdown',
    'dashboard.mobileSales.clientVisitLogs': 'Client Visit Logs',
    'dashboard.analytics.analyticsPeriod': 'Analytics Period',
    'dashboard.analytics.selectTimeRange': 'Select time range for data analysis',
    'dashboard.analytics.3months': '3 Months',
    'dashboard.analytics.6months': '6 Months',
    'dashboard.analytics.12months': '12 Months',
    'dashboard.analytics.quickReports': 'Quick Reports',
    'dashboard.realtime.autoRefreshOn': 'Auto-Refresh ON',
    'dashboard.realtime.autoRefreshOff': 'Auto-Refresh OFF',
    'dashboard.realtime.lastUpdated': 'Last updated',
    'dashboard.reports.reportTemplates': 'Report Templates',
    'dashboard.reports.customReportBuilder': 'Custom Report Builder',
    'dashboard.reports.reportHistory': 'Report History',
    'dashboard.reports.preBuiltTemplates': 'Pre-Built Report Templates',
    'dashboard.reports.selectTemplate': 'Select a template for quick report generation',
    'dashboard.reports.accessPreviousReports': 'Access previously generated reports',
    'dashboard.salon.overview': 'Overview',
    'dashboard.salon.invoices': 'Invoices',
    'dashboard.salon.paymentHistory': 'Payment History',
    'dashboard.salon.appointments': 'Appointments',
    'dashboard.salon.inventory': 'Inventory',
    'dashboard.salon.pricingTier': 'Pricing Tier',
    'dashboard.salon.creditLimit': 'Credit Limit',
    'dashboard.salon.currentBalance': 'Current Balance',
    'dashboard.salon.paymentTerms': 'Payment Terms',
  },
  ru: {
    // Navigation
    'nav.shop': 'Магазин',
    'nav.cart': 'Моя корзина',
    'nav.account': 'Мой аккаунт',
    'nav.dashboard': 'Панель управления',
    'nav.products': 'Продукты',
    'nav.orders': 'Заказы',

    // Hamburger Menu
    'menu.home': 'Главная',
    'menu.categories': 'Категории',
    'menu.brands': 'Бренды',
    'menu.newArrivals': 'Новинки',
    'menu.sale': 'Распродажа',
    'menu.aboutUs': 'О нас',
    'menu.contact': 'Контакты',
    'menu.privacyPolicy': 'Политика конфиденциальности',
    'menu.termsConditions': 'Условия и положения',

    // Common
    'common.search': 'Поиск',
    'common.searchPlaceholder': 'введите для поиска',
    'common.filter': 'Фильтр',
    'common.filters': 'Фильтры',
    'common.sort': 'Сортировка',
    'common.add': 'Добавить',
    'common.edit': 'Редактировать',
    'common.delete': 'Удалить',
    'common.save': 'Сохранить',
    'common.cancel': 'Отмена',
    'common.close': 'Закрыть',
    'common.loading': 'Загрузка...',
    'common.price': 'Цена',
    'common.quantity': 'Количество',
    'common.total': 'Итого',
    'common.clearAllFilters': 'Очистить все фильтры',
    'common.noProductsFound': 'Продукты не найдены',
    'common.adjustFilters': 'Попробуйте изменить фильтры или поисковый запрос',

    // Product Catalog
    'catalog.welcome': 'Добро пожаловать!',
    'catalog.description': 'Откройте для себя нашу тщательно подобранную коллекцию премиальных косметических продуктов',
    'catalog.gridView': 'Вид сетки',
    'catalog.listView': 'Вид списка',
    'catalog.addedToCart': 'Продукт успешно добавлен в корзину!',
    'catalog.brandName': 'Celine Claire',
    'catalog.tagline': 'for Unique, Unmatched, Lasting Results',
    'catalog.callToAction': 'YOU MUST TRY IT TO BELIEVE IT!',
    'catalog.uniqueTitle': 'Celine Claire is Unique',
    'catalog.uniqueSubtitle': 'unlike any other',
    'catalog.uniqueAction': 'learn why',
    'catalog.expertTitle': 'Celine Claire is Expert',
    'catalog.expertSubtitle': 'get best advice',
    'catalog.expertAction': 'Learn how',
    'catalog.caresTitle': 'Celine Claire Cares',
    'catalog.caresSubtitle': 'seek medical help',
    'catalog.caresAction': 'Get healthy!',

    // Expert Modal - Holistic Hair Care (Russian)
    'expert.modal.title': 'Экспертные советы Celine Claire',
    'expert.modal.intro': 'Примите комплексный подход Celine Claire к уходу за волосами, чтобы раскрыть истинный потенциал ваших волос!',
    'expert.modal.paragraph1': 'Этот тщательно разработанный тест поможет вам не только выбрать лучший продукт, соответствующий вашим потребностям, но и предложить экспертные решения, которые выходят за рамки расходов на косметику!',
    'expert.modal.paragraph2': 'В Celine мы понимаем, что ваши волосы - это больше, чем просто стильное заявление; это отражение вашего общего здоровья, образа жизни и даже вашего эмоционального или психологического состояния.',
    'expert.modal.paragraph3': 'Мы хотим помочь вам понять, что такие факторы, как уровень стресса, диета, ежедневные привычки и даже ваше окружение играют важную роль в здоровье ваших волос и кожи головы.',
    'expert.modal.paragraph4': 'Хотя наши продукты признаны и отмечены за их уникальную функциональность и долговременные результаты, мы стремимся предоставить вам больше, чем просто роскошное качество.',
    'expert.modal.paragraph5': 'Мы хотим поддержать вас знаниями о различных факторах, влияющих на здоровье ваших волос, чтобы вы могли достичь наилучших возможных результатов, а не просто инвестировать в продукты, которые только улучшают поверхность.',
    'expert.modal.toggleTitle': 'Нажмите здесь, чтобы увидеть основные факторы',
    'expert.modal.factor1.title': '**Уровень стресса:**',
    'expert.modal.factor1.content': 'Высокий уровень стресса может привести к истончению и выпадению волос. Управление стрессом с помощью практик осознанности, упражнений и правильного сна может способствовать более здоровой коже головы и фолликулам.',
    'expert.modal.factor2.title': '**Общее питание:**',
    'expert.modal.factor2.content': 'Сбалансированная диета, богатая витаминами и минералами, необходима. Продукты с высоким содержанием Омега-3, витаминов A, C, D и E, а также цинка и железа способствуют более сильным и блестящим волосам. Подумайте о включении питательных продуктов для питания ваших волос изнутри.',
    'expert.modal.factor3.title': '**Ежедневная рутина:**',
    'expert.modal.factor3.content': 'Ваши ежедневные привычки должны поддерживать здоровье ваших волос. Мягкое очищение, кондиционирование и минимизация тепловых стилей могут привести к более сильным и упругим волосам. Создайте ритуал, который балует вашу кожу головы и способствует росту волос.',
    'expert.modal.factor4.title': '**Выбор образа жизни:**',
    'expert.modal.factor4.content': 'Живете ли вы в оживленном городском центре или в тихой деревне, ваш образ жизни влияет на состояние ваших волос. Горные среды могут подвергать ваши волосы загрязнению; следовательно, безопасные меры, такие как регулярное очищение и использование средств с антисептическими добавками, могут помочь снизить вред. В сельской местности такие факторы, как влажность и воздействие солнца, требуют индивидуального ухода для оптимального здоровья волос.',
    'expert.modal.factor5.title': '**Климатические соображения:**',
    'expert.modal.factor5.content': 'Различные климатические условия могут влиять на уровень влажности и силу ваших волос. Адаптация вашего режима ухода за волосами для включения увлажняющих средств в сухом климате и защитных стилей во влажных областях обеспечит вам сохранение роскошных локонов круглый год.',
    'expert.modal.paragraph6': 'Allow us to uncover and address all possible underlying issues together, and responsibly ensure, restore and maintain your hair\'s beauty and vitality.',
    'expert.modal.paragraph7': 'Take control of your hair health, click on the button below and undertake our TEST and explore our range of expert solutions that go beyond beauty. Visit our website today to discover how Celine can elevate your hair care routine and enhance your overall well-being. Your journey to healthier hair starts now!',
    'expert.modal.paragraph8': 'In your Test Result page, you may also receive our "SURPRISE GIFT"!',
    'expert.modal.buttonText': 'Take your Hair and Well-being Assessment Test now',

    // Product
    'product.addToCart': 'Добавить в корзину',
    'product.outOfStock': 'Нет в наличии',
    'product.inStock': 'В наличии',
    'product.details': 'Детали продукта',
    'product.reviews': 'Отзывы',
    'product.description': 'Описание',

    // Product Names
    'products.arganOil.name': 'Аргановое масло',
    'products.hairMask.name': 'Маска для волос',
    'products.purpleRepairMask.name': 'Фиолетовая восстанавливающая маска',
    'products.hairEnhancementShampoo.name': 'Шампунь для улучшения волос',
    'products.volumiserShampoo.name': 'Шампунь для объема',
    'products.volumiserConditioner.name': 'Кондиционер для объема',
    'products.hydratingShampoo.name': 'Увлажняющий шампунь',
    'products.hydratingConditioner.name': 'Увлажняющий кондиционер',
    'products.cck1And2.name': 'Набор очищающего шампуня и кератина CCK1 и 2',
    'products.cck3.name': 'Ежедневный кератиновый шампунь CCK3',
    'products.cck4.name': 'Ежедневный кератиновый кондиционер CCK4',
    'products.aquaStylingWax.name': 'Воск для укладки волос Aqua',
    'products.deadSeaSaltSpray.name': 'Спрей с солью Мертвого моря',
    'products.heatShieldSpray.name': 'Спрей для защиты от тепла',
    'products.moisturizingCream.name': 'Крем мартобный кондиционер без смывания',
    'products.curlEssence.name': 'Кондиционер для локонов без смывания',
    'products.tecplexKits.name': 'Киоти профессиональные системы построения связи',
    'products.tecplexNo3.name': 'TecPlex No.3',
    'products.tecplexNo7.name': 'TecPlex No7 Oil',
    'products.silverShampoo.name': 'Шампунь серебряный',
    'products.flexyBrush.name': 'Гибкая щетка для волос',
    'products.flexyBrushSet.name': 'Профессиональный набор гибких щеток (4 шт.)',

    // Product Descriptions
    'products.arganOil.description': 'Что такое аргановое масло? Аргановое масло - или "жидкое золото", как многие его называют - изготавливается из свежих ядер плодов арганового дерева в Марокко. Чистое аргановое масло использовалось веками для приготовления пищи и в качестве домашнего средства для здоровья и красоты, включая выпадение волос. Сегодня его можно найти в ряде средств по уходу за волосами и кожей, включая марокканское аргановое масло Celine Claire.',
    'products.hydratingShampoo.description': 'Ищете увлажняющий шампунь, который может укрепить ваши пряди, не утяжеляя волосы. Этот увлажняющий шампунь для ежедневного ухода, насыщенный богатым антиоксидантами аргановым маслом и восстанавливающими питательными веществами для утоления и питания сухих волос. Обеспечивает увлажнение для здоровых волос для ежедневного очищения и повышения влажности.',
    'products.hydratingConditioner.description': 'Интенсивно увлажняющий кондиционер. Представляем новый увлажняющий кондиционер Celine Claire Cosmetic. Этот замечательный продукт - идеальное решение для увлажнения ваших волос. Вьющиеся волосы вас раздражают? Поврежденные волосы вас огорчают? Оживите и восстановите внешний вид ваших волос с помощью этого увлажняющего кондиционера, изготовленного из арганового масла высшего качества.',
    'products.silverShampoo.description': 'Фиолетовый шампунь - это теория цвета в самом простом виде: временный оттенок делает все типы светлых и блондинистых волос похожими на свежие из салона. У Celine Claire есть новый фиолетовый шампунь, который превратит ваши желтые, медные блондинистые тона в красивый оттенок блонда снова. Независимо от того, стали ли вы платиновой блондинкой или просто хотите осветлить свой естественный оттенок, этот фиолетовый шампунь останавливает медность и оживляет ваш оттенок всего за одно мытье.',
    'products.purpleRepairMask.description': 'Having blonde hair is never easy for your time or wallet. Blonde hair whether you are born with it or it comes at the expense of your stylist requires a lot of work. Celine Claire Cosmetic introduces a brand-new product that aims to make having luscious blonde locks. When we rely on pricey in-salon color treatments to maintain the blonde tresses we need to do upkeep at home. To solve this issue of upkeep in between touch-ups, Celine Claire presents the Celine Claire Purple Repair Mask. This mask is the perfect product to help you in your battle with brassiness. The deep purple tones out the orange and copper tones that develop on blonde hair. Why does this happen? Brassiness can happen due to several factors, such as UV exposure, hard water damage, or chlorine in swimming pools. Our Purple Repair Mask treats unwanted brass warm tones without you having to step foot inside a hair salon. Celine Claire has one of the best complete hair care systems dedicated to blonde hair. Start your blonde hair care journey by washing your luscious locks with the Celine Claire Purple Shampoo once or twice a week. This will depend on how often you shampoo your hair. Follow up on the Celine Claire Purple Repair Mask. This moisturizing product is rich in Argan oil that helps the hair repair damage and remains silky soft. This hair care system is essential for maintaining your blonde color. The repair mask is very rich and is the perfect solution to over-processed and damaged blonde hair.',
    'products.hairMask.description': 'Mascara for hair that intensively moisturizes and conditions damaged hair, restores moisture, and leaves hair silky smooth.',
    'products.hairEnhancementShampoo.description': 'Professional-grade shampoo that strengthens and enhances hair health with advanced formula.',
    'products.volumiserShampoo.description': 'Shampoo that adds volume and body to fine, flat hair without weighing it down.',
    'products.volumiserConditioner.description': 'Lightweight conditioning that complements the volumiser shampoo and maintains volume and adds shine.',
    'products.cck1And2.description': 'Professional keratin treatment system for salon-quality smoothing and frizz control.',
    'products.cck3.description': 'Sulfate-free daily shampoo specially formulated to maintain and extend keratin treatments.',
    'products.cck4.description': 'Nourishing daily conditioner that preserves keratin treatments while adding moisture and shine.',
    'products.aquaStylingWax.description': 'Water-based styling wax that provides flexible hold and texture with a natural finish.',
    'products.deadSeaSaltSpray.description': 'Texturizing spray with Dead Sea minerals that creates beachy waves and adds volume.',
    'products.heatShieldSpray.description': 'Protective spray that shields hair from heat damage up to 230°C while adding shine.',
    'products.moisturizingCream.description': 'Rich leave-in conditioning cream that provides all-day hydration and frizz control.',
    'products.curlEssence.description': 'Leave-in conditioner that defines curls and reduces frizz while enhancing natural curl pattern.',
    'products.tecplexKits.description': 'Professional bond-building treatment system that repairs and strengthens damaged hair.',
    'products.tecplexNo3.description': 'At-home hair perfector that rebuilds broken bonds and improves hair strength.',
    'products.tecplexNo7.description': 'Lightweight bonding oil that adds brilliant shine while repairing and protecting hair.',
    'products.flexyBrush.description': 'Flexible detangling brush with soft bristles that glides through wet or dry hair without pulling.',
    'products.flexyBrushSet.description': 'Professional set of 4 flexible detangling brushes for complete hair care - perfect for salons and families.',

    // Cart
    'cart.empty': 'Ваша корзина пуста',
    'cart.checkout': 'Оформить заказ',
    'cart.subtotal': 'Промежуточный итог',
    'cart.shipping': 'Доставка',
    'cart.tax': 'Налог',

    // Auth
    'auth.login': 'Войти',
    'auth.register': 'Регистрация',
    'auth.logout': 'Выйти',
    'auth.email': 'Электронная почта',
    'auth.password': 'Пароль',
    'auth.forgotPassword': 'Забыли пароль?',
    'auth.emailAddress': 'Адрес электронной почты',
    'auth.enterEmail': 'Введите ваш адрес электронной почты',
    'auth.enterPassword': 'Введите ваш пароль',
    'auth.rememberMe': 'Запомнить меня',
    'auth.signingIn': 'Вход...',
    'auth.signIn': 'Войти',
    'auth.orContinueWith': 'Или продолжить с',
    'auth.google': 'Google',
    'auth.facebook': 'Facebook',
    'auth.loginAs': 'Войти как',
    'auth.registerAs': 'Зарегистрироваться как',
    'auth.onlineCustomer': 'Онлайн-клиент',
    'auth.salonStore': 'Салон или магазин',
    'auth.salesRepresentative': 'Торговый представитель',
    'auth.management': 'Управление',
    'auth.admin': 'Администратор',
    'auth.fullName': 'Полное имя',
    'auth.enterFullName': 'Введите ваше полное имя',
    'auth.confirmPassword': 'Подтвердите пароль',
    'auth.phoneNumber': 'Номер телефона',
    'auth.enterPhoneNumber': 'Введите ваш номер телефона',
    'auth.whatsappNumber': 'Номер WhatsApp',
    'auth.enterWhatsappNumber': 'Введите ваш номер WhatsApp',
    'auth.addressInformation': 'Информация об адресе',
    'auth.street': 'Адрес улицы',
    'auth.enterStreetAddress': 'Введите адрес улицы',
    'auth.city': 'Город',
    'auth.enterCity': 'Введите ваш город',
    'auth.emirateOrState': 'Эмират или штат',
    'auth.enterEmirateOrState': 'Введите ваш эмират или штат',
    'auth.country': 'Страна',
    'auth.enterCountry': 'Введите вашу страну',
    'auth.zipCode': 'Почтовый индекс',
    'auth.enterZipCode': 'Введите ваш почтовый индекс',
    'auth.agreeToTerms': 'Я согласен с условиями и положениями',
    'auth.receivePromotions': 'Получать рекламные письма',
    'auth.receiveRecommendations': 'Получать рекомендации по продуктам',
    'auth.creating': 'Создание аккаунта...',
    'auth.createAccount': 'Создать аккаунт',
    'auth.welcomeBack': 'Привет, рады видеть тебя!',
    'auth.welcomeBackDesc': 'Давай, заходи!\n\nИли, если ты здесь впервые, пожалуйста, зарегистрируйся.',
    'auth.createYourAccount': 'Create Your Account',
    'auth.createYourAccountDesc': 'Join CosmeticStore and start your personalized beauty journey today',
    'auth.signInTab': 'Sign In',
    'auth.createAccountTab': 'Create Account',
    'auth.dontHaveAccount': 'Нет аккаунта?',
    'auth.signUpNow': 'Зарегистрируйтесь сейчас',
    'auth.alreadyHaveAccount': 'Уже есть аккаунт?',
    'auth.needHelp': 'Нужна помощь?',
    'auth.liveChatSupport': 'Помощь в чате',
    'auth.available247': 'Доступно 24/7',
    'auth.emailSupport': 'Помощь по электронной почте',
    'auth.phoneSupport': 'Телефонная помощь',
    'auth.yourSecurityMatters': 'Ваша безопасность важна',
    'auth.secureAuthentication': 'Безопасная аутентификация',
    'auth.secureAuthDesc': 'Ваши данные защищены шифрованием промышленного стандарта',
    'auth.privacyProtected': 'Конфиденциальность защищена',
    'auth.privacyProtectedDesc': 'Мы никогда не передаем вашу личную информацию третьим лицам',
    'auth.verifiedSecure': 'Проверено безопасно',
    'auth.verifiedSecureDesc': 'SSL-сертифицирован и PCI-совместим для безопасных транзакций',
    'auth.continueAsGuest': 'Продолжить как гость',
    'auth.continueAsGuestDesc': 'Вы можете оформить заказ без создания аккаунта, но вы упустите эти преимущества:',
    'auth.exclusiveRewards': 'Эксклюзивные награды',
    'auth.exclusiveRewardsDesc': 'Зарабатывайте баллы за каждую покупку и получайте специальные скидки',
    'auth.fasterCheckout': 'Быстрая оплата',
    'auth.fasterCheckoutDesc': 'Сохраните свои данные для быстрого и легкого оформления заказа в будущем',
    'auth.orderTracking': 'Отслеживание заказов',
    'auth.orderTrackingDesc': 'Отслеживайте ваши отправки и просматривайте весь журнал заказов',
    'auth.personalizedExperience': 'Персонализированный опыт',
    'auth.personalizedExperienceDesc': 'Получайте рекомендации по продуктам, адаптированные к вашим предпочтениям',
    'auth.createAccountAfter': 'Вы можете создать аккаунт после оформления заказа',
    'auth.forgotPasswordTitle': 'Forgot Password?',
    'auth.forgotPasswordDesc': 'Enter your email address and we\'ll send you a link to reset your password',
    'auth.sendResetLink': 'Send Reset Link',
    'auth.sending': 'Sending...',
    'auth.checkYourEmail': 'Check Your Email',
    'auth.checkYourEmailDesc': 'We\'ve sent a password reset link to',
    'auth.checkYourEmailDesc2': 'Please check your inbox and follow the instructions.',
    'auth.didntReceiveEmail': 'Didn\'t receive the email? Check your spam folder or try again in a few minutes.',

    // Privacy Policy (legacy keys)
    'privacy.title': 'Политика конфиденциальности',
    'privacy.companyName': 'Селин Клер Косметик',
    'privacy.lastUpdated': 'Последнее обновление',
    'privacy.tableOfContents': 'Содержание',
    'privacy.printPolicy': 'Печать политики',
    'privacy.introduction': 'Введение',
    'privacy.introText': 'Celine Claire Cosmetic ("мы", "нас", "наша") стремится защитить вашу конфиденциальность и обеспечить безопасный и приятный опыт покупок. Эта Политика конфиденциальности объясняет, как мы собираем, используем и защищаем вашу личную информацию, когда вы посещаете наш веб-сайт, используете наши услуги или совершаете покупки у нас.',
    'privacy.yourRights': 'Ваши права',
    'privacy.yourRightsText': 'Вы имеете право на доступ, исправление или удаление вашей личной информации. Вы также имеете право подать жалобу, если считаете, что ваши права на конфиденциальность были нарушены.',
    'privacy.dataCollection': 'Сбор данных',
    'privacy.dataUsage': 'Использование данных',
    'privacy.dataProtection': 'Защита данных',
    'privacy.thirdParties': 'Передача третьим лицам',
    'privacy.retention': 'Хранение данных',
    'privacy.yourChoices': 'Ваш выбор',
    'privacy.contactUs': 'Свяжитесь с нами',
    'privacy.backToShopping': 'Вернуться к покупкам',

    // Filters
    'filters.filters': 'Фильтры',
    'filters.clearAll': 'Очистить все',
    'filters.results': 'Результаты',
    'filters.categories': 'Категории',
    'filters.allProducts': 'Все продукты',
    'filters.skincare': 'Медицинский уход',
    'filters.makeup': 'Макияж',
    'filters.fragrance': 'Ароматика',
    'filters.haircare': 'Уход за волосами',
    'filters.priceRange': 'Диапазон цен',
    'filters.brands': 'Бренды',
    'filters.skinType': 'Тип кожи',
    'filters.normal': 'Нормальная',
    'filters.dry': 'Жирная',
    'filters.oily': 'Масляная',
    'filters.combination': 'Смешанная',
    'filters.sensitive': 'Чувствительная',

    // Sort
    'sort.sortBy': 'Сортировка по:',
    'sort.relevance': 'Связанность',
    'sort.priceLowToHigh': 'Цена: от низкой к высокой',
    'sort.priceHighToLow': 'Цена: от высокой к низкой',
    'sort.highestRated': 'Наибольший рейтинг',
    'sort.newestFirst': 'Сначала новые',

    // Currency
    'currency.amount': 'Сумма',
    'currency.enterAmount': 'Введите сумму',
    'currency.fromCurrency': 'Из валюты',
    'currency.convertedAmounts': 'Преобразованные суммы:',

    // Celine Home Modal
    'celine.modalMessage': 'You are on the way to visit the Celine Claire Cosmetics Home site .... Are you sure you want to leave the Celine Claire Store?',
    'celine.modalSubtext': '... the Celine Home will open in a new window, you can always come back here ... enjoy your journey!',
    'celine.home': 'CELINE Home',
    'celine.cart': 'CART',
    'celine.login': 'LOGIN',

    // Shopping Cart
    'cart.title': 'Shopping Cart',
    'cart.item': 'item',
    'cart.items': 'items',
    'cart.inYourCart': 'in your cart',
    'cart.yourCartIsEmpty': 'Your Cart is Empty',
    'cart.emptyCartMessage': "Looks like you haven't added any beauty products yet. Start shopping to fill your cart!",
    'cart.startShopping': 'Start Shopping',
    'cart.shopByCategory': 'Shop by Category',
    'cart.youMightLike': 'You Might Like',
    'cart.orderSummary': 'Order Summary',
    'cart.estimatedTax': 'Estimated Tax',
    'cart.free': 'FREE',
    'cart.proceedToCheckout': 'Proceed to Checkout',
    'cart.continueShopping': 'Continue Shopping',
    'cart.freeShipping': 'Free Shipping',
    'cart.freeShippingDesc': 'On orders over $50',
    'cart.securePayment': 'Secure Payment',
    'cart.securePaymentDesc': 'SSL encrypted checkout',
    'cart.easyReturns': 'Easy Returns',
    'cart.easyReturnsDesc': '30-day return policy',
    'cart.promoCode': 'Promo Code',
    'cart.codeApplied': 'Code Applied',
    'cart.enterPromoCode': 'Enter promo code',
    'cart.apply': 'Apply',
    'cart.pleaseEnterPromoCode': 'Please enter a promo code',
    'cart.availableCodes': 'Available Codes:',
    'cart.variant': 'Variant',
    'cart.save': 'Save',
    'cart.saveForLater': 'Save for Later',
    'cart.remove': 'Remove',
    'cart.estimatedDelivery': 'Estimated delivery',
    'cart.itemTotal': 'Item Total:',
    'cart.discount': 'Discount',

    // Dashboard
    'dashboard.loadingDashboard': 'Loading dashboard...',
    'dashboard.quickActions': 'Quick Actions',
    'dashboard.recentOrders': 'Recent Orders',
    'dashboard.admin.topSellingProducts': 'Top Selling Products',
    'dashboard.admin.systemAlerts': 'System Alerts',
    'dashboard.management.inventoryAlerts': 'Inventory Alerts',
    'dashboard.management.topCategories': 'Top Categories',
    'dashboard.management.salesTeamPerformance': 'Sales Team Performance',
    'dashboard.sales.leadPipeline': 'Lead Pipeline',
    'dashboard.sales.recentInteractions': 'Recent Interactions',
    'dashboard.sales.yourTopProducts': 'Your Top Products',
    'dashboard.mobileSales.recentClients': 'Recent Clients',
    'dashboard.mobileSales.sampleInventory': 'Sample Inventory',
    'dashboard.mobileSales.commissionBreakdown': 'Commission Breakdown',
    'dashboard.mobileSales.clientVisitLogs': 'Client Visit Logs',
    'dashboard.analytics.analyticsPeriod': 'Analytics Period',
    'dashboard.analytics.selectTimeRange': 'Select time range for data analysis',
    'dashboard.analytics.3months': '3 Months',
    'dashboard.analytics.6months': '6 Months',
    'dashboard.analytics.12months': '12 Months',
    'dashboard.analytics.quickReports': 'Quick Reports',
    'dashboard.realtime.autoRefreshOn': 'Auto-Refresh ON',
    'dashboard.realtime.autoRefreshOff': 'Auto-Refresh OFF',
    'dashboard.realtime.lastUpdated': 'Last updated',
    'dashboard.reports.reportTemplates': 'Report Templates',
    'dashboard.reports.customReportBuilder': 'Custom Report Builder',
    'dashboard.reports.reportHistory': 'Report History',
    'dashboard.reports.preBuiltTemplates': 'Pre-Built Report Templates',
    'dashboard.reports.selectTemplate': 'Select a template for quick report generation',
    'dashboard.reports.accessPreviousReports': 'Access previously generated reports',
    'dashboard.salon.overview': 'Overview',
    'dashboard.salon.invoices': 'Invoices',
    'dashboard.salon.paymentHistory': 'Payment History',
    'dashboard.salon.appointments': 'Appointments',
    'dashboard.salon.inventory': 'Inventory',
    'dashboard.salon.pricingTier': 'Pricing Tier',
    'dashboard.salon.creditLimit': 'Credit Limit',
    'dashboard.salon.currentBalance': 'Current Balance',
    'dashboard.salon.paymentTerms': 'Payment Terms',
  },
};

// Merge base translations with privacy/terms translations for each language
export const translations: Record<Language, Translations> = {
  en: { ...baseTranslations.en, ...privacyTermsTranslations.en },
  ar: { ...baseTranslations.ar, ...privacyTermsTranslations.ar },
  fa: { ...baseTranslations.fa, ...privacyTermsTranslations.fa },
  ru: { ...baseTranslations.ru, ...privacyTermsTranslations.ru },
};

export const getTranslation = (key: string, language: Language): string => {
  return translations[language]?.[key] || key;
};

export const isRTL = (language: Language): boolean => {
  return language === 'ar' || language === 'fa';
};